import type {
  AddFiscalDocumentItemPayload,
  AddSalesDocumentItemPayload,
  ApiErrorResponse,
  BankStatementCandidateDto,
  BankStatementDto,
  BankStatementLineDto,
  ConvertQuoteToInvoicePayload,
  CompanySettingsDto,
  ConfirmDeliveryNotePayload,
  DeliveryNoteDto,
  PublicDeliveryNoteDto,
  EntitlementsSummaryDto,
  WarehouseDto,
  CreateWarehousePayload,
  UpdateWarehousePayload,
  SupplierDto,
  CreateSupplierPayload,
  UpdateSupplierPayload,
  GoodsReceiptDto,
  CreateGoodsReceiptPayload,
  StockLevelDto,
  UserDto,
  LoginPayload,
  LoginResponseDto,
  CreateUserPayload,
  UpdateUserPayload,
  SignupPayload,
  SignupResponseDto,
  CreateCompanyAsAdminPayload,
  ConfirmAccountPayload,
  ForgotPasswordPayload,
  ResetPasswordPayload,
  ChangePasswordPayload,
  MessageResponseDto,
  OtpRequestPayload,
  OtpVerifyPayload,
  OnboardingCreateCompanyPayload,
  OnboardingCreateCompanyResponseDto,
  EmailTemplateKey,
  EmailTemplateDto,
  UpdateEmailTemplatePayload,
  EmailTemplatePreviewDto,
  PlatformMailSettingsDto,
  UpdatePlatformMailSettingsPayload,
  CompanyAdminDto,
  PlatformUserAdminDto,
  CompanyStatsDto,
  FiscalizationLogEntryDto,
  CloudApiLogEntryDto,
  BankStatementImportLogEntryDto,
  MobileLogEntryDto,
  PfrResponseLogEntryDto,
  CourierApiLogEntryDto,
  SefApiLogEntryDto,
  SystemApiKeyDto,
  AdminModuleDto,
  ModuleGroupDto,
  CompanyModuleDto,
  CompanySubscriptionAdminDto,
  CompanyUsageDto,
  AdminAuditLogDto,
  MinimaxStatusDto,
  MinimaxReportHistoryDto,
  StatementImportAddressDto,
  StatementProcessingHistoryDto,
  FcmDeviceDto,
  FcmDeviceDetailDto,
  DeviceActivityLogDto,
  DeviceModuleDto,
  DeviceCommand,
  MobileUserAccessDto,
  ModuleDto,
  PackageDto,
  ServiceEndpointDto,
  UpdateServiceEndpointPayload,
  CloudApiIntegrationDto,
  CreateCloudApiIntegrationPayload,
  CloudApiNewKeyDto,
  PrintAgentListItemDto,
  PrintAgentAdminListItemDto,
  PrintAgentAdminKeyDto,
  PrintAgentConnectionDto,
  ContractTemplateDto,
  ContractSettingsDto,
  ContractProviderSettingsDto,
  ContractDto,
  ContractPlaceholderDefDto,
  ContractDurationOption,
  ContractDiscountedPriceDto,
  AcceptContractPayload,
  PrintAgentKeyDto,
  PrintAgentNewKeyDto,
  CloudApiWebhookDto,
  CreateCloudApiWebhookPayload,
  CloudApiNetworkDeviceDto,
  BusinessLocationOptionDto,
  CompanyBankAccountDto,
  ReportSummaryDto,
  BillingUsageReportDto,
  ProductImportSummaryDto,
  PurchaseCalculationDto,
  CostAllocationMethod,
  WarehouseIssueOrderDto,
  CloudApiActivityLogEntryDto,
  ShopifyStoreDto,
  ShopifySettingsResponseDto,
  ShopifySettingsUpdatePayload,
  ShopifyOrdersResponseDto,
  ShopifyOrderSyncDto,
  ShopifyRefundSyncDto,
  MerchantProStoreDto,
  CreateMerchantProStorePayload,
  UpdateMerchantProStorePayload,
  MerchantProOrdersResponseDto,
  MerchantProOrderSyncDto,
  MerchantProWebhookInfoDto,
  MerchantProProductMappingDto,
  MerchantProImportProductsResultDto,
  UpdateMerchantProProductMappingPayload,
  CreateAdvanceSalePayload,
  CreateCustomerPayload,
  CreateFiscalDocumentPayload,
  CreateProductPayload,
  CreateRecurringInvoiceTemplatePayload,
  CreateSalesDocumentPayload,
  CustomerDto,
  DashboardSummaryDto,
  EInvoiceDto,
  FiscalDocumentDto,
  FiscalizeDocumentPayload,
  ProductDto,
  ProductAttributeGroupDto,
  ProductAttributeOptionDto,
  ProductVariationDto,
  ProductRemovableIngredientDto,
  RegisterPaymentPayload,
  RegisterSalesDocumentPaymentPayload,
  RecurringInvoiceTemplateDto,
  ReconciliationMode,
  SalesDocumentDto,
  SalesDocumentStatus,
  SalesDocumentType,
  SefSettingsDto,
  SmtpSettingsDto,
  PfrSettingsDto,
  PfrCertificateParseResultDto,
  PfrCertificateBundleResultDto,
  FiscalDeviceIdentityDto,
  FiscalDeviceDto,
  RegisterFiscalDeviceInput,
  CompanyFcmDeviceDto,
  PfrReceiptsConvertResultDto,
  PfrReceiptsImportSummaryDto,
  PfrReceiptsImportDetailDto,
  PfrReceiptMappingSuggestionDto,
  MapPfrReceiptItemInput,
  MapPfrReceiptItemResultDto,
  IpsPgwSettingsDto,
  IpsPgwTransactionDto,
  OtpCardSettingsDto,
  OtpCardTransactionDto,
  IntesaCardSettingsDto,
  IntesaCardTransactionDto,
  BexCourierSettingsDto,
  PostaCourierSettingsDto,
  CityExpressCourierSettingsDto,
  ShipmentNotificationSettingsDto,
  UpdateCityExpressCourierSettingsPayload,
  CourierListItemDto,
  ShipmentDto,
  RaiffeisenCardSettingsDto,
  RaiffeisenCardTransactionDto,
  MyInvoicesResponseDto,
  UpdateSefSettingsPayload,
  UpdateSmtpSettingsPayload,
  UpdatePfrSettingsPayload,
  UpdateIpsPgwSettingsPayload,
  UpdateOtpCardSettingsPayload,
  UpdateIntesaCardSettingsPayload,
  UpdateRaiffeisenCardSettingsPayload,
  UpdateBexCourierSettingsPayload,
  UpdatePostaCourierSettingsPayload,
  DispatchShipmentPayload,
  UpdateFiscalDocumentItemPayload,
  UpdateSalesDocumentItemPayload,
  UpdateCustomerPayload,
  UpdateCompanySettingsPayload,
  UpdateCompanyProfileAdminPayload,
  UpdateProductPayload,
  TaxRateDto,
  UnitDto,
  BackupDestinationDto,
  BackupDestinationsListDto,
  BackupDestinationPayload,
  BackupRunDto,
  ExpenseDto,
  ExpenseSettingsDto,
  CreateExpensePayload,
  UpdateExpensePayload,
  UpdateExpenseSettingsPayload,
} from "@finora/types";

/**
 * @finora/api-client
 *
 * Namerno koristi samo `fetch` (dostupan i u browseru, i u Tauri
 * webview-u, i u Capacitor WebView-u) - bez XHR-specifičnih ili
 * Node-specifičnih API-ja koji bi otežali kasnije pakovanje aplikacije
 * kao desktop/mobilne aplikacije.
 */

export interface CompanyUserAdminDto {
  id: string;
  fullName: string;
  email: string;
  companyName: string;
  role: string;
  isActive: boolean;
  verified: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

export interface CompanyInvoicesAdminDto {
  issuerCompanyName: string;
  summary: {
    paidCount: number;
    paidAmount: number;
    unpaidCount: number;
    unpaidAmount: number;
    currency: string;
  };
  invoices: Array<{
    id: string;
    documentNumber: string;
    issueDate: string;
    dueDate: string | null;
    currency: string;
    grossAmount: number;
    paidAmount: number;
    dueAmount: number;
    status: string;
    isPaid: boolean;
    publicLinkToken: string | null;
  }>;
}

export type LpfrPlatformDto = "WINDOWS" | "LINUX" | "ANDROID";
export interface LpfrAdminItemDto {
  companyId: string;
  companyName: string;
  taxId: string;
  platforms: LpfrPlatformDto[];
  licenses: { keyPrefix: string; label: string | null; revoked: boolean; lastUsedAt: string | null }[];
  windows: { count: number; last: string | null; version: string | null };
  linux: { count: number; last: string | null; version: string | null };
  invoices: { total: number; last: string | null; viaAndroid: number; viaComputer: number; jids: string[]; androidDevices: string[] };
}
export interface LpfrAdminOverviewDto {
  totals: { companies: number; windows: number; linux: number; android: number; invoices: number; deniedDownloads: number };
  items: LpfrAdminItemDto[];
  recent: { id: string; createdAt: string; companyName: string; keyPrefix: string | null; platform: string; version: string | null; ip: string | null; allowed: boolean }[];
}

export interface CompanyAprSyncFieldDto {
  key: string;
  label: string;
  current: string | null;
  found: string | null;
  status: "SAME" | "FILL" | "DIFF" | "NONE";
}
export interface CompanyAprSyncPreviewDto {
  pib: string;
  companyName: string;
  foundName: string;
  activityName: string | null;
  owner: string | null;
  email: string | null;
  fields: CompanyAprSyncFieldDto[];
  accounts: { accountNumber: string; bankName: string | null; status: string | null; isNew: boolean }[];
}
export interface LoyaltyProgramDto {
  is_active: boolean;
  name: string;
  points_enabled: boolean;
  points_per_100: number;
  point_value: number;
  receipt_window_hours: number;
  rules: LoyaltyStampRuleDto[];
}

export interface LoyaltyStampRuleDto {
  id: string;
  name: string;
  stamps_required: number;
  is_active: boolean;
  items: { product_id: string; variation_id: string | null }[];
}

export interface LoyaltyStampRuleInput {
  name?: string;
  stamps_required?: number;
  is_active?: boolean;
  items?: { product_id: string; variation_id?: string | null }[];
}

export interface HorecaTaxRowDto {
  label: string;
  rate: number | null;
  base: number;
  tax: number;
  gross: number;
}

export interface HorecaKepDto {
  period: { from: string; to: string };
  business_location: { id: string; name: string } | null;
  days: {
    ordinal: number;
    date: string;
    receipts: number;
    refunds_count: number;
    by_tax: HorecaTaxRowDto[];
    sales_gross: number;
    refunds_gross: number;
    turnover_gross: number;
    running_total: number;
  }[];
  totals: { receipts: number; by_tax: HorecaTaxRowDto[]; sales_gross: number; refunds_gross: number; turnover_gross: number };
}

export interface HorecaDpuDto {
  date: string;
  business_location: { id: string; name: string } | null;
  receipts: number;
  refunds_count: number;
  first_fiscal_number: string | null;
  last_fiscal_number: string | null;
  sales_gross: number;
  refunds_gross: number;
  turnover_gross: number;
  by_payment: { method: string; sales: number; refunds: number; net: number }[];
  by_tax: HorecaTaxRowDto[];
  by_cashier: { user_id: string | null; name: string | null; receipts: number; gross: number }[];
  shifts: { number: number; opened_at: string; closed_at: string | null; opened_by: string | null; opening_cash: number; counted_cash: number | null }[];
}

export interface HorecaTableDto {
  id: string;
  zone_id: string;
  label: string;
  seats: number;
  x: number;
  y: number;
  shape: string;
  sort_order: number;
  is_active: boolean;
}

export interface HorecaZoneDto {
  id: string;
  business_location_id: string;
  name: string;
  sort_order: number;
  is_active: boolean;
  tables: HorecaTableDto[];
}

export interface HorecaStationDto {
  id: string;
  business_location_id: string | null;
  name: string;
  category_ids: string[];
  product_ids: string[];
  output_mode: "SCREEN" | "PRINTER" | "BOTH";
  printer_name: string | null;
  sort_order: number;
  is_active: boolean;
}

export interface HorecaKitchenItemDto {
  id: string;
  product_id: string;
  name: string;
  quantity: number;
  choice: { variation?: { name?: string }; addons?: { name?: string }[]; without?: string[]; note?: string } | null;
  course: number;
  station_id: string | null;
  status: "SENT" | "PREPARING" | "READY" | "SERVED";
  sent_at: string | null;
}

export interface HorecaKitchenTicketDto {
  order_id: string;
  table_label: string | null;
  note: string | null;
  items: HorecaKitchenItemDto[];
}

export interface PosShiftDto {
  id: string;
  number: number;
  status: "OPEN" | "CLOSED";
  businessLocationId: string;
  openedAt: string;
  closedAt: string | null;
  openedBy: string;
  closedBy: string;
  openingCash: number;
  countedCash: number | null;
  autoClosed: boolean;
  note: string;
}

export interface PosShiftReportDto {
  shift: PosShiftDto;
  sales: { count: number; gross: number; tax: number };
  refunds: { count: number; gross: number; tax: number };
  net: { gross: number; tax: number };
  payments: { method: string; sales: number; refunds: number; net: number }[];
  cash: { opening: number; sales: number; refunds: number; expected: number; counted: number | null; difference: number | null };
}

export interface HorecaPromotionDto {
  id: string;
  kind: "HAPPY_HOUR" | "COMBO";
  name: string;
  is_active: boolean;
  business_location_id: string | null;
  days: number[];
  time_from: string | null;
  time_to: string | null;
  valid_from: string | null;
  valid_to: string | null;
  discount_type: "PERCENT" | "FIXED_PRICE" | null;
  discount_value: number | null;
  product_ids: string[];
  category_ids: string[];
  combo_items: { product_id: string; variation_id: string | null; quantity: number }[];
  combo_price: number | null;
}

export type HorecaPromotionInput = Partial<Omit<HorecaPromotionDto, "id">>;

export interface HorecaSalesReportDto {
  from: string;
  to: string;
  receipts: number;
  refunds_count: number;
  sales_gross: number;
  refunds_gross: number;
  turnover_gross: number;
  by_article: { product_id: string | null; name: string; quantity: number; gross: number; discount: number }[];
  by_category: { category_id: string | null; name: string; quantity: number; gross: number }[];
  by_cashier: { user_id: string | null; name: string | null; receipts: number; refunds: number; gross: number }[];
  by_hour: { hour: number; receipts: number; gross: number }[];
}

export interface HorecaShiftPlanDto {
  id: string;
  user_id: string;
  business_location_id: string | null;
  date: string;
  start_time: string;
  end_time: string;
  note: string | null;
  minutes: number;
}

export interface HorecaCountLineDto {
  product_id: string;
  name: string;
  unit: string;
  expected: number;
  counted: number | null;
  difference: number | null;
  value: number | null;
}

export interface EotpAddressDto { street?: string; houseNumber?: string; city?: string; postalCode?: string; municipality?: string; code?: string }
export interface EotpPartyDto extends EotpAddressDto { name: string; pib?: string; mb?: string; contactName?: string; phone?: string; email?: string }
export interface EotpItemDto { name: string; code?: string; quantity: number; unit: string; gtin?: string; description?: string }
export interface EotpDataDto {
  kind?: "Ext" | "Int";
  recipient: EotpPartyDto;
  despatchAddress?: EotpAddressDto;
  deliveryAddress?: EotpAddressDto;
  method: 1 | 2 | 3 | 4 | 5;
  carrier?: EotpPartyDto;
  vehiclePlate?: string;
  driver?: { email?: string; firstName?: string; lastName?: string; phone?: string; licenseNo?: string };
  courier?: { firstName?: string; lastName?: string; idNumber?: string };
  plannedDespatchAt?: string;
  plannedDeliveryEndAt: string;
  actualDespatchAt: string;
  note?: string;
  deliveryInstructions?: string;
  orderRef?: string;
  goodsReturn?: boolean;
  weightKg?: number;
  volumeM3?: number;
  packages?: number;
  items: EotpItemDto[];
}
export interface EotpremnicaDto {
  id: string; number: string; kind: string; status: string;
  remote_status: string | null; remote_status_label: string | null; remote_id: string | null;
  sales_document_id: string | null; issue_date: string | null;
  recipient_name: string; recipient_pib: string; items_count: number; last_error: string | null;
  sent_at: string | null; created_at: string; data?: EotpDataDto;
}
export interface EotpValidationDto { is_valid: boolean; has_warnings: boolean; has_errors: boolean; messages: { code: string; description: string; severity: string; path?: string }[] }

export interface KasaPaketDto {
  id: string;
  companyId: string;
  kind: "OBICNA" | "HORECA";
  label: string | null;
  businessLocationId: string | null;
  locationName: string | null;
  jid: string | null;
  activeUntil: string | null;
  releaseCount: number;
  createdAt: string;
}
export interface KasaPaketiOverviewDto {
  total: number;
  bound: number;
  obicna: number;
  horeca: number;
  items: KasaPaketDto[];
}

export interface LpfrOverviewDto {
  module_active: boolean;
  license: { key: string; key_prefix: string } | null;
  download: { windows_url: string; linux_url: string } | null;
  installations: { jid: string | null; platform: string; device: string | null; invoices: number; last_at: string }[];
  downloads: { windows: { count: number; last: string | null; version: string | null }; linux: { count: number; last: string | null; version: string | null } };
}

export interface HorecaCountDto {
  id: string;
  warehouse_id: string;
  warehouse_name: string;
  name: string;
  status: "OPEN" | "APPLIED" | "CANCELLED";
  created_at: string;
  applied_at: string | null;
  lines?: HorecaCountLineDto[];
  summary?: { total: number; counted: number; with_difference: number; value_difference: number };
}

export interface HorecaStaffDto {
  user_id: string;
  name: string;
  role: string;
  see_all: boolean;
  zone_ids: string[];
  table_ids: string[];
}

export interface HorecaWorkSessionDto {
  id: string;
  user_id: string;
  clock_in_at: string;
  clock_out_at: string | null;
  note: string | null;
  minutes: number;
}

export interface HorecaWorkReportDto {
  period: { from: string; to: string };
  workers: { user_id: string; name: string | null; total_minutes: number; total_hours: number; sessions: HorecaWorkSessionDto[] }[];
}

export interface LoyaltyStatsDto {
  members: number;
  total_stamps: number;
  total_points_given: number;
  rewards_waiting: number;
  points_outstanding: number;
}

export interface LoyaltyLookupDto {
  loyalty_id: string;
  name: string | null;
  card: {
    stamp_cards: { rule_id: string; name: string; stamps: number; required: number; rewards: number }[];
    rewards: number;
    points: number;
    point_value: number;
    points_value_total: number;
  };
}

export interface AppReleaseAdminDto {
  platform: "WINDOWS" | "LINUX" | "MACOS" | "ANDROID" | "IOS";
  version: string;
  url: string;
  notes: string;
  mandatory: boolean;
  minSupported: string;
  updatedAt: string | null;
}

export interface AppReleaseSavePayload {
  version: string;
  url: string;
  notes: string;
  mandatory: boolean;
  minSupported: string;
}

export interface CompanyDeviceDto {
  id: string;
  platform: "ANDROID" | "IOS" | "WINDOWS" | string;
  name: string | null;
  model: string | null;
  osVersion: string | null;
  appVersion: string | null;
  userName: string;
  userEmail: string;
  blocked: boolean;
  lastActiveAt: string;
  createdAt: string;
  modules: Array<{ featureKey: string; name: string; allowed: boolean }>;
  lpfr?: {
    state: string | null;
    checkedAt: string | null;
    ok?: boolean;
    message?: string;
    jid?: string;
    device?: string;
    softwareVersion?: string;
    appletVersion?: string;
    lastInvoiceNumber?: string;
  } | null;
}

export interface NormativIngredientDto {
  id: string;
  name: string;
  sku: string;
  unit: string;
}
export interface NormativRecipeLineDto {
  id: string;
  variationId: string | null;
  variationName: string | null;
  ingredientId: string;
  ingredientName: string;
  unit: string;
  quantity: string;
  wastePercent: string;
}
export interface NormativRecipeLinePayload {
  variationId?: string | null;
  ingredientId: string;
  quantity: string | number;
  wastePercent?: string | number;
}
export interface NormativMovementDto {
  id: string;
  createdAt: string;
  productId: string;
  warehouseId: string;
  quantity: string;
  reason: string;
  source: string;
  fiscalDocumentId: string | null;
  resultingQuantity: string;
  negative: boolean;
}
export interface NormativConsumptionRowDto {
  day: string;
  productId: string;
  name: string;
  unit: string;
  quantity: string;
}
export interface NormativAddonSaleRowDto {
  name: string;
  times: number;
  ingredientName: string | null;
  unit: string | null;
  totalQuantity: string | null;
}

export interface EarhivAdminStorageItemDto {
  companyId: string;
  companyName: string;
  taxId: string;
  bucket: string;
  accessKeyId: string;
  provisionedAt: string | null;
  files: number;
  usedBytes: number;
  quotaGb: number;
  garageBytes: number | null;
  garageObjects: number | null;
  garageQuotaBytes: number | null;
}
export interface EarhivAdminStorageDto {
  configured: boolean;
  garageOnline: boolean;
  endpoint: string;
  totals: { companies: number; files: number; usedBytes: number; garageBytes: number };
  items: EarhivAdminStorageItemDto[];
}
export interface EarhivAdminSecretDto {
  bucket: string;
  accessKeyId: string;
  secretAccessKey: string;
  endpoint: string;
}

export class ApiError extends Error {
  constructor(public readonly response: ApiErrorResponse) {
    super(response.message);
    this.name = "ApiError";
  }
}


// --- Kalkulacije v2 ---------------------------------------------------------
export interface CalcLineCalc {
  lineNet: number; allocatedCost: number; totalCost: number; unitCost: number; vatAmount: number;
  marginPercent: number | null; sellingPriceNet: number | null; sellingPriceGross: number | null; priceManual: boolean;
}
export interface CalcLineDto {
  productId: string | null; sku: string | null; barcode: string | null; supplierCode: string | null;
  name: string; unit: string; quantity: number; purchasePrice: number; discountPercent: number; taxRatePercent: number;
  marginPercent: number | null; sellingPriceGross: number | null; priceManual: boolean;
  currentSellingGross?: number | null; calc?: CalcLineCalc; matched?: boolean;
}
export interface CalcCostDto { name: string; amount: number; allocationMethod: string }
export interface CalcWarning { level: "ERROR" | "WARNING" | "INFO"; code: string; message: string; lineIndex?: number }
export interface CalcSummary {
  totalPurchase: number; totalCosts: number; totalValue: number; totalVat: number; totalGross: number;
  totalQuantity: number; avgMarkupPercent: number | null; avgSellingGross: number | null;
}
export interface CalcInputPayload {
  type?: string; documentDate?: string | null; receiptDate?: string | null; warehouseId?: string | null; supplierId?: string | null;
  sourceDocType?: string | null; sourceDocNumber?: string | null; sefInvoiceId?: string | null; dueDate?: string | null;
  currency?: string | null; exchangeRate?: number | null; allocationMethod?: string; note?: string | null;
  lines?: CalcLineDto[]; costs?: CalcCostDto[];
  pricing?: { mode: "MARKUP" | "MARGIN"; marginPercent: number; rounding: "NONE" | "WHOLE" | "TEN" | "NINETY_NINE"; lineIndexes?: number[] } | null;
}
export interface CalcListItem {
  id: string; number: string; type: string; status: string; documentDate: string; sourceDocNumber: string | null;
  supplierName: string | null; warehouseName: string | null; currency: string; totalPurchase: number; totalCosts: number; totalGross: number;
}
export interface PurchaseInvoiceItem {
  id: string; sefInvoiceId: string | null; number: string; supplierName: string; supplierTaxId: string | null;
  issueDate: string | null; currency: string; grossAmount: string; status: string | null; source: string; expenseId: string | null;
  decision: string | null; decisionComment: string | null; decidedAuto: boolean; itemsSummary?: string;
}
export interface PurchaseInvoiceDetail {
  id: string; number: string; issueDate: string | null; dueDate: string | null; currency: string;
  supplierName: string; supplierTaxId: string | null; supplierAddress: string | null;
  netAmount: number; vatAmount: number; grossAmount: number; documentDiscount: number;
  status: string | null; decision: string | null; decisionComment: string | null; expenseId: string | null;
  note?: string;
  lines: { lineNo: number; name: string; sellerCode: string | null; description?: string | null; unit: string; quantity: number; unitPrice: number; discountPercent: number; lineNet: number; taxRatePercent: number }[];
}
export interface SefAutoRejectRuleDto { id: string; supplierTaxId: string | null; supplierName: string | null; matchText: string; reason: string; enabled: boolean }
export interface CalcListResponse { stats: { draft: number; pendingApproval: number; postedThisMonth: number }; items: CalcListItem[] }
export interface CalcDto extends CalcInputPayload {
  id: string; number: string; type: string; status: string; documentDate: string; supplierName: string | null; warehouseName: string | null;
  supplierTaxId: string | null; goodsReceiptId: string | null; postedAt: string | null;
  lines: CalcLineDto[]; costs: CalcCostDto[]; summary: CalcSummary; warnings: CalcWarning[];
  history: { id: string; userName: string | null; action: string; details: string | null; createdAt: string }[];
}
export interface CalcPreviewDto {
  summary: CalcSummary; warnings: CalcWarning[];
  lines: { marginPercent: number | null; sellingPriceGross: number | null; priceManual: boolean; calc: CalcLineCalc }[];
}
export interface SefInvoiceItem {
  id: string; sefInvoiceId: string; number: string; supplierName: string; supplierTaxId: string | null;
  issueDate: string | null; currency: string; grossAmount: number | string; status: string | null; source: string; alreadyUsed?: boolean;
}

export interface FinoraApiClientOptions {
  baseUrl: string;
  getAuthHeaders?: () => Record<string, string>;
  onUnauthorized?: () => void;
}

// E-arhiv (16.10.2026) - arhivska knjiga po obrascu AK ------------------------
export interface EarhivSettingsDto {
  archiveName: string | null;
  responsiblePerson: string | null;
  consentNumber: string | null;
  consentDate: string | null;
  registeredAt: string | null;
}
export interface EarhivCategoryDto {
  id: string;
  code: string;
  groupName: string | null;
  name: string;
  retentionYears: number | null;
  permanent: boolean;
  retentionNote: string | null;
  ruleSource: string | null;
  docType: string | null;
  retentionLabel: string;
  sortOrder: number;
  isActive: boolean;
}
export interface EarhivCategoryPayload {
  code: string;
  groupName?: string | null;
  name: string;
  retentionYears?: number | null;
  permanent?: boolean;
  retentionNote?: string | null;
  ruleSource?: string | null;
  docType?: string | null;
  isActive?: boolean;
}
export interface EarhivEntryDto {
  id: string;
  categoryId: string;
  rowNumber: number;
  entryDate: string | null;
  year: number;
  yearTo: number | null;
  content: string;
  classCode: string;
  retentionLabel: string;
  consentNumber: string | null;
  quantity: string | null;
  location: string | null;
  minutesNumber: string | null;
  minutesDate: string | null;
  note: string | null;
  docCount: number | null;
  sizeBytes: number | null;
  origin: "AUTO" | "MANUAL";
  locked: boolean;
}
export interface EarhivEntryPayload {
  categoryId?: string;
  year?: number;
  yearTo?: number | null;
  content?: string | null;
  quantity?: string | null;
  location?: string | null;
  minutesNumber?: string | null;
  minutesDate?: string | null;
  note?: string | null;
}

export interface EarhivFileDto {
  id: string;
  categoryId: string;
  categoryCode: string;
  categoryName: string;
  year: number;
  fileName: string;
  mimeType: string | null;
  description: string | null;
  sizeBytes: number;
  sha256: string;
  createdAt: string;
}
export interface EarhivStorageDto {
  files: number;
  usedBytes: number;
  quotaBytes: number;
  maxFileBytes: number;
  backend: "S3" | "NONE";
}

export class FinoraApiClient {
  constructor(private readonly options: FinoraApiClientOptions) {}

  private async request<T>(
    path: string,
    init?: RequestInit & { idempotencyKey?: string },
  ): Promise<T> {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(this.options.getAuthHeaders?.() ?? {}),
      ...(init?.headers as Record<string, string> | undefined),
    };
    if (init?.idempotencyKey) {
      headers["Idempotency-Key"] = init.idempotencyKey;
    }

    const res = await fetch(`${this.options.baseUrl}${path}`, {
      ...init,
      headers,
    });

    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Došlo je do neočekivane greške. Pokušajte ponovo.",
          path,
          timestamp: new Date().toISOString(),
        };
      }
      if (res.status === 401) {
        this.options.onUnauthorized?.();
      }
      throw new ApiError(body);
    }

    if (res.status === 204) {
      return undefined as T;
    }
    const text = await res.text();
    if (!text) {
      return undefined as T;
    }
    return JSON.parse(text) as T;
  }

  // --- Dashboard ---------------------------------------------------------
  getDashboard(params?: { chartMonths?: number }) {
    const qs = new URLSearchParams();
    if (params?.chartMonths) qs.set("chartMonths", String(params.chartMonths));
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<DashboardSummaryDto>(`/dashboard${suffix}`);
  }

  // --- Products ------------------------------------------------------------
  listProducts(params?: { search?: string; categoryId?: string; ingredients?: "include" | "only" }) {
    const qs = new URLSearchParams();
    if (params?.ingredients) qs.set("ingredients", params.ingredients);
    if (params?.search) qs.set("search", params.search);
    if (params?.categoryId) qs.set("categoryId", params.categoryId);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<ProductDto[]>(`/products${suffix}`);
  }

  markFiscalDocumentIssued(id: string, variant: "sale" | "refund") {
    return this.request<{ success: boolean }>(`/fiscal-documents/${id}/mark-issued`, {
      method: "POST",
      body: JSON.stringify({ variant }),
    });
  }

  listProductCodes() {
    return this.request<{ id: string; sku: string; name: string; barcode: string | null; unitPriceGross: number }[]>(`/products/codes`);
  }

  generateProductCodes() {
    return this.request<{ total: number; updated: number }>(`/products/generate-codes`, { method: "POST" });
  }

  getProduct(id: string) {
    return this.request<ProductDto>(`/products/${id}`);
  }

  createProduct(payload: CreateProductPayload) {
    return this.request<ProductDto>("/products", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateProduct(id: string, payload: UpdateProductPayload) {
    return this.request<ProductDto>(`/products/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  archiveProduct(id: string) {
    return this.request<ProductDto>(`/products/${id}/archive`, { method: "POST" });
  }

  async uploadProductImage(id: string, file: File): Promise<ProductDto> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${this.options.baseUrl}/products/${id}/image`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Otpremanje slike nije uspelo.",
          path: `/products/${id}/image`,
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as ProductDto;
  }

  async convertPfrReceiptsJsonToMinimaxXlsx(file: File): Promise<PfrReceiptsConvertResultDto> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${this.options.baseUrl}/reports/pfr-receipts-export/to-minimax-xlsx`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Konverzija nije uspela.",
          path: "/reports/pfr-receipts-export/to-minimax-xlsx",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return res.json();
  }

  /** Istorija uvoza (Izveštaji -> Poreska uprava -> MiniMax). */
  listPfrReceiptsImports() {
    return this.request<PfrReceiptsImportSummaryDto[]>("/reports/pfr-receipts-export/imports");
  }

  getPfrReceiptsImportDetail(importId: string) {
    return this.request<PfrReceiptsImportDetailDto>(`/reports/pfr-receipts-export/imports/${importId}`);
  }

  downloadPfrReceiptsImportXlsx(importId: string) {
    return this.request<{ base64: string; fileName: string | null }>(
      `/reports/pfr-receipts-export/imports/${importId}/xlsx`,
    );
  }

  deletePfrReceiptsImport(importId: string) {
    return this.request<{ deleted: boolean }>(`/reports/pfr-receipts-export/imports/${importId}`, {
      method: "DELETE",
    });
  }

  /** "Mapiraj" nespojen artikal - pamti se po nazivu i primenjuje retroaktivno. */
  mapPfrReceiptItemToProduct(payload: MapPfrReceiptItemInput) {
    return this.request<MapPfrReceiptItemResultDto>("/reports/pfr-receipts-export/mappings", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  /** "Dodaj artikal" - pravi novi artikal iz stavke računa i odmah ga mapira. */
  createPfrReceiptProduct(payload: { name: string }) {
    return this.request<MapPfrReceiptItemResultDto>("/reports/pfr-receipts-export/create-product", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  /** Predlog za "Mapiraj" modal - postojeće mapiranje (ako ga ima) i do 5 najsličnijih artikala. */
  getPfrReceiptMappingSuggestions(name: string) {
    return this.request<PfrReceiptMappingSuggestionDto>(
      `/reports/pfr-receipts-export/mapping-suggestions?name=${encodeURIComponent(name)}`,
    );
  }

  async importProductsCsv(
    file: File,
    priceIncludesVat: boolean,
    defaultTaxRateId: string,
  ): Promise<{ created: number; skipped: number; errors: string[] }> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("priceIncludesVat", String(priceIncludesVat));
    formData.append("defaultTaxRateId", defaultTaxRateId);
    const res = await fetch(`${this.options.baseUrl}/products/import-csv`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Uvoz artikala nije uspeo.",
          path: "/products/import-csv",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return res.json();
  }

  // --- Atributi artikla --------------------------------------------------
  listProductAttributeGroups(productId: string) {
    return this.request<ProductAttributeGroupDto[]>(`/products/${productId}/attributes`);
  }

  createProductAttributeGroup(productId: string, name: string) {
    return this.request<ProductAttributeGroupDto>(`/products/${productId}/attributes`, {
      method: "POST",
      body: JSON.stringify({ name }),
    });
  }

  deleteProductAttributeGroup(productId: string, groupId: string) {
    return this.request(`/products/${productId}/attributes/${groupId}`, { method: "DELETE" });
  }

  createProductAttributeOption(
    productId: string,
    groupId: string,
    payload: { name: string; isFree: boolean; priceModifier?: string; imageUrl?: string },
  ) {
    return this.request<ProductAttributeOptionDto>(`/products/${productId}/attributes/${groupId}/options`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateProductAttributeOption(
    productId: string,
    optionId: string,
    payload: { name?: string; isFree?: boolean; priceModifier?: string; imageUrl?: string | null },
  ) {
    return this.request<ProductAttributeOptionDto>(`/products/${productId}/attributes/options/${optionId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  deleteProductAttributeOption(productId: string, optionId: string) {
    return this.request(`/products/${productId}/attributes/options/${optionId}`, { method: "DELETE" });
  }

  // --- Varijacije artikla (28.09.2026) -----------------------------------
  listProductVariations(productId: string) {
    return this.request<ProductVariationDto[]>(`/products/${productId}/variations`);
  }

  createProductVariation(
    productId: string,
    payload: { name: string; priceModifier?: string; barcode?: string | null; sku?: string | null },
  ) {
    return this.request<ProductVariationDto>(`/products/${productId}/variations`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateProductVariation(
    productId: string,
    variationId: string,
    payload: {
      name?: string;
      priceModifier?: string;
      barcode?: string | null;
      sku?: string | null;
      status?: "ACTIVE" | "ARCHIVED";
    },
  ) {
    return this.request<ProductVariationDto>(`/products/${productId}/variations/${variationId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  deleteProductVariation(productId: string, variationId: string) {
    return this.request(`/products/${productId}/variations/${variationId}`, { method: "DELETE" });
  }

  // --- "Ukloni sastojke" (28.09.2026) -------------------------------------
  listProductRemovableIngredients(productId: string) {
    return this.request<ProductRemovableIngredientDto[]>(`/products/${productId}/removable-ingredients`);
  }

  createProductRemovableIngredient(productId: string, payload: { name: string }) {
    return this.request<ProductRemovableIngredientDto>(`/products/${productId}/removable-ingredients`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  deleteProductRemovableIngredient(productId: string, ingredientId: string) {
    return this.request(`/products/${productId}/removable-ingredients/${ingredientId}`, { method: "DELETE" });
  }

  // --- Kategorije artikala (28.09.2026) -----------------------------------
  listProductCategories() {
    return this.request<{ id: string; companyId: string; name: string; colorHex: string | null; sortOrder: number }[]>(
      "/product-categories",
    );
  }

  createProductCategory(payload: { name: string; colorHex?: string | null }) {
    return this.request<{ id: string; companyId: string; name: string; colorHex: string | null; sortOrder: number }>(
      "/product-categories",
      { method: "POST", body: JSON.stringify(payload) },
    );
  }

  deleteProductCategory(id: string) {
    return this.request(`/product-categories/${id}`, { method: "DELETE" });
  }

  // --- Units -----------------------------------------------------------------
  listUnits() {
    return this.request<UnitDto[]>("/units");
  }

  createUnit(payload: { name: string }) {
    return this.request<UnitDto>("/units", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  deleteUnit(id: string) {
    return this.request<void>(`/units/${id}`, { method: "DELETE" });
  }

  // --- Customers -----------------------------------------------------------
  listCustomers(search?: string) {
    const suffix = search ? `?search=${encodeURIComponent(search)}` : "";
    return this.request<CustomerDto[]>(`/customers${suffix}`);
  }

  getCustomer(id: string) {
    return this.request<CustomerDto>(`/customers/${id}`);
  }

  createCustomer(payload: CreateCustomerPayload) {
    return this.request<CustomerDto>("/customers", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateCustomer(id: string, payload: UpdateCustomerPayload) {
    return this.request<CustomerDto>(`/customers/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  archiveCustomer(id: string) {
    return this.request<CustomerDto>(`/customers/${id}/archive`, {
      method: "POST",
    });
  }

  // --- Tax rates -------------------------------------------------------------
  listTaxRates() {
    return this.request<TaxRateDto[]>("/tax-rates");
  }
  /** Vraća apsolutni URL za preuzimanje PDF-a - koristi se direktno u <a href>. */
  getSalesDocumentPdfUrl(id: string) {
    return `${this.options.baseUrl}/sales-documents/${id}/pdf`;
  }

  /**
   * PDF endpoint je iza login-a (JWT), a window.open()/<a href> ne šalju
   * Authorization header - zato se ovde PDF preuzima preko fetch-a (koji
   * NOSI auth header) i vraća kao Blob URL koji se onda može otvoriti.
   */
  async downloadSalesDocumentPdfBlobUrl(id: string): Promise<string> {
    const res = await fetch(this.getSalesDocumentPdfUrl(id), {
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      if (res.status === 401) {
        this.options.onUnauthorized?.();
      }
      throw new Error(`PDF preuzimanje nije uspelo (HTTP ${res.status}).`);
    }
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  }

  getPublicDeliveryNotePdfUrl(token: string) {
    return `${this.options.baseUrl}/public/delivery-notes/${token}/pdf`;
  }

  // --- Fiscal documents ------------------------------------------------------
  createFiscalDocument(payload: CreateFiscalDocumentPayload) {
    return this.request<FiscalDocumentDto>("/fiscal-documents", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  getFiscalDocument(id: string) {
    return this.request<FiscalDocumentDto>(`/fiscal-documents/${id}`);
  }

  /** Avans-Prodaja na stvarno primljen iznos - vidi CreateAdvanceSalePayload. */
  createAdvanceSale(payload: CreateAdvanceSalePayload, idempotencyKey: string) {
    return this.request<FiscalDocumentDto>("/fiscal-documents/advance-sale", {
      method: "POST",
      body: JSON.stringify(payload),
      idempotencyKey,
    });
  }

  listFiscalDocuments(filters: {
    // String umesto usko tipizovane unije - backend (FiscalDocumentsController)
    // već podržava i više statusa razdvojenih zarezom (npr.
    // "FISCALIZED,REFUNDED") - vidi FiscalDocumentsListPage.tsx, podrazumevani
    // filter "Svi" namerno isključuje Nacrt (DRAFT).
    status?: string;
    from?: string;
    to?: string;
    limit: number | "all";
    offset?: number;
  }) {
    const params = new URLSearchParams();
    if (filters.status) params.set("status", filters.status);
    if (filters.from) params.set("from", filters.from);
    if (filters.to) params.set("to", filters.to);
    params.set("limit", String(filters.limit));
    if (filters.offset) params.set("offset", String(filters.offset));
    return this.request<{ total: number; items: FiscalDocumentDto[] }>(
      `/fiscal-documents?${params.toString()}`,
    );
  }

  refundFiscalDocument(id: string, idempotencyKey: string) {
    return this.request<FiscalDocumentDto>(`/fiscal-documents/${id}/refund`, {
      method: "POST",
      body: JSON.stringify({ idempotencyKey }),
      idempotencyKey,
    });
  }

  /** "Stampaj kopiju" - PFR KOPIJA (reprint), dozvoljeno i posle storna,
   * NE menja status dokumenta - vidi FiscalDocumentsService.copy(). */
  copyFiscalDocument(id: string, idempotencyKey: string) {
    return this.request<FiscalDocumentDto>(`/fiscal-documents/${id}/copy`, {
      method: "POST",
      body: JSON.stringify({ idempotencyKey }),
      idempotencyKey,
    });
  }

  /** Posalji fiskalni racun kupcu na email (PDF prilog) - razgovor
   * 26.09.2026. Ako `email` nije poslat, backend koristi email sacuvanog
   * kupca na dokumentu (ako postoji). */
  sendFiscalDocumentEmail(
    id: string,
    payload: { email?: string; format?: "thermal80" | "thermal58" | "a4" },
  ) {
    return this.request<{ sentTo: string }>(`/fiscal-documents/${id}/send-email`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  /** Task #38 - "Storno avansnog računa zbog izdavanja gotovinskog" - zatvara
   * avansni PFR lanac (Аванс Рефундација) i vraća NACRT novog gotovinskog
   * (PROMET) računa koji ga referencira - kasir ga dovršava na kasi. */
  closeAdvanceWithCashSale(id: string, idempotencyKey: string) {
    return this.request<FiscalDocumentDto>(
      `/fiscal-documents/${id}/close-advance-with-cash-sale`,
      {
        method: "POST",
        body: JSON.stringify({ idempotencyKey }),
        idempotencyKey,
      },
    );
  }

  getFiscalServiceStatus(businessLocationId?: string) {
    const qs = businessLocationId ? `?businessLocationId=${encodeURIComponent(businessLocationId)}` : "";
    return this.request<{
      status: "ONLINE" | "OFFLINE" | "DEGRADED";
      jid?: string | null;
      location?: string | null;
    }>(`/fiscal-documents/service-status${qs}`);
  }

  updateFiscalDocument(
    id: string,
    payload: {
      note?: string | null;
      discountAmount?: string;
      customerId?: string | null;
      buyerPib?: string | null;
      buyerName?: string | null;
      buyerIdType?: string | null;
      buyerAddress?: string | null;
      buyerOptionalField?: string | null;
      pfrDocumentType?: "PROMET" | "AVANS" | "OBUKA" | "KOPIJA" | "PREDRACUN";
    },
  ) {
    return this.request<FiscalDocumentDto>(`/fiscal-documents/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  addFiscalDocumentItem(id: string, payload: AddFiscalDocumentItemPayload) {
    return this.request<FiscalDocumentDto>(`/fiscal-documents/${id}/items`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateFiscalDocumentItem(
    id: string,
    itemId: string,
    payload: UpdateFiscalDocumentItemPayload,
  ) {
    return this.request<FiscalDocumentDto>(
      `/fiscal-documents/${id}/items/${itemId}`,
      { method: "PATCH", body: JSON.stringify(payload) },
    );
  }

  removeFiscalDocumentItem(id: string, itemId: string) {
    return this.request<FiscalDocumentDto>(
      `/fiscal-documents/${id}/items/${itemId}`,
      { method: "DELETE" },
    );
  }

  registerPayment(
    id: string,
    payload: RegisterPaymentPayload,
    idempotencyKey: string,
  ) {
    return this.request<FiscalDocumentDto>(`/fiscal-documents/${id}/payment`, {
      method: "POST",
      body: JSON.stringify(payload),
      idempotencyKey,
    });
  }

  fiscalizeDocument(id: string, payload: FiscalizeDocumentPayload) {
    return this.request<FiscalDocumentDto>(
      `/fiscal-documents/${id}/fiscalize`,
      {
        method: "POST",
        body: JSON.stringify(payload),
        idempotencyKey: payload.idempotencyKey,
      },
    );
  }

  // --- eFakture (mock u prvoj fazi) ---------------------------------------
  listEInvoices() {
    return this.request<EInvoiceDto[]>("/e-invoices");
  }
  getEInvoiceItems(id: string) {
    return this.request<{
      number: string; counterpartyName: string; issueDate: string; currency: string; status: string; grossAmount: string;
      lines: { name: string; description: string | null; unit: string; quantity: string; unitPriceGross: string; discountAmount: string; netAmount: string; taxAmount: string; grossAmount: string }[];
    }>(`/e-invoices/${id}/items`);
  }

  // --- SEF (produkciona integracija) -----------------------------------------
  getSefSettings() {
    return this.request<SefSettingsDto>("/e-invoices/sef/settings");
  }

  updateSefSettings(payload: UpdateSefSettingsPayload) {
    return this.request<SefSettingsDto>("/e-invoices/sef/settings", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  sendSalesDocumentToSef(salesDocumentId: string) {
    return this.request(`/e-invoices/sef/send/${salesDocumentId}`, { method: "POST" });
  }

  // --- MiniMax (knjigovodstvena integracija) ---------------------------------
  getMinimaxStatus() {
    return this.request<MinimaxStatusDto>("/integrations/minimax/status");
  }

  saveMinimaxCredentials(clientId: string, clientSecret: string) {
    return this.request<MinimaxStatusDto>("/integrations/minimax/credentials", {
      method: "POST",
      body: JSON.stringify({ clientId, clientSecret }),
    });
  }

  connectMinimax(username: string, password: string) {
    return this.request<MinimaxStatusDto>("/integrations/minimax/connect", {
      method: "POST",
      body: JSON.stringify({ username, password }),
    });
  }

  listMinimaxOrganisations() {
    return this.request<{ ID: number; Name: string }[]>("/integrations/minimax/organisations");
  }

  listMinimaxPaymentMethods() {
    return this.request<{ ID: number; Name: string; Type?: string }[]>("/integrations/minimax/payment-methods");
  }

  listMinimaxVatAccountingTypes() {
    return this.request<{ Code: string; Name: string; IssuedRecived?: string }[]>(
      "/integrations/minimax/vat-accounting-types",
    );
  }

  /**
   * Best effort - vidi MinimaxOAuthService.lookupPostalCode. Iza
   * "minimax_api" modula je (isti kao ostatak integracije), zato pozivalac
   * (modal "Novi kupac") mora da hvata grešku i ćutke nastavi bez
   * auto-popune ako firma nema MiniMax povezan.
   */
  lookupMinimaxPostalCode(code: string) {
    return this.request<{ code: string; city: string } | null>(
      `/integrations/minimax/postal-codes/lookup?code=${encodeURIComponent(code)}`,
    );
  }

  selectMinimaxOrganisation(organisationId: string, organisationName: string) {
    return this.request<MinimaxStatusDto>("/integrations/minimax/organisation", {
      method: "POST",
      body: JSON.stringify({ organisationId, organisationName }),
    });
  }

  listMinimaxWarehouses() {
    return this.request<{ WarehouseId: number; Name: string }[]>("/integrations/minimax/warehouses");
  }

  selectMinimaxWarehouse(warehouseId: string, warehouseName: string) {
    return this.request<MinimaxStatusDto>("/integrations/minimax/warehouse", {
      method: "POST",
      body: JSON.stringify({ warehouseId, warehouseName }),
    });
  }

  saveMinimaxStatementEmail(statementEmail: string) {
    return this.request<MinimaxStatusDto>("/integrations/minimax/statement-email", {
      method: "POST",
      body: JSON.stringify({ statementEmail }),
    });
  }

  disconnectMinimax() {
    return this.request<MinimaxStatusDto>("/integrations/minimax/disconnect", { method: "POST" });
  }

  clearMinimaxCredentials() {
    return this.request<MinimaxStatusDto>("/integrations/minimax/clear-credentials", { method: "POST" });
  }

  syncMinimaxItems() {
    return this.request<{ created: number; updated: number; skipped: number; errors: string[] }>(
      "/integrations/minimax/sync-items",
      { method: "POST" },
    );
  }

  sendMinimaxDailyReport(date?: string) {
    return this.request<{ status: string; itemCount: number; skippedItemCount: number }>(
      "/integrations/minimax/send-daily-report",
      { method: "POST", body: JSON.stringify({ date }) },
    );
  }

  saveMinimaxPostingSettings(payload: {
    cashPaymentMethodId?: string;
    cardPaymentMethodId?: string;
    vatCalculationType?: string;
  }) {
    return this.request<MinimaxStatusDto>("/integrations/minimax/posting-settings", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  sendMinimaxDailyInvoicePosting(date?: string) {
    return this.request<{ postingStatus: string }>(
      "/integrations/minimax/send-daily-invoice-posting",
      { method: "POST", body: JSON.stringify({ date }) },
    );
  }

  listMinimaxReports() {
    return this.request<MinimaxReportHistoryDto[]>("/integrations/minimax/reports");
  }

  listMyStatementImportAddresses() {
    return this.request<StatementImportAddressDto[]>("/izvodi/obrada/addresses");
  }

  generateMyStatementImportAddress(label?: string) {
    return this.request<StatementImportAddressDto>("/izvodi/obrada/addresses", {
      method: "POST",
      body: JSON.stringify({ label }),
    });
  }

  regenerateMyStatementImportAddress(addressId: string) {
    return this.request<StatementImportAddressDto>(`/izvodi/obrada/addresses/${addressId}/regenerate`, {
      method: "POST",
    });
  }

  deleteMyStatementImportAddress(addressId: string) {
    return this.request<{ success: boolean }>(`/izvodi/obrada/addresses/${addressId}`, { method: "DELETE" });
  }

  getMyStatementProcessingStats() {
    return this.request<{ received: number; success: number; failed: number; duplicates: number; totalCost: string }>(
      "/izvodi/obrada/stats",
    );
  }

  listMyStatementProcessingHistory() {
    return this.request<StatementProcessingHistoryDto[]>("/izvodi/obrada/history");
  }

  listStatementImportAddresses(companyId: string) {
    return this.request<StatementImportAddressDto[]>(
      `/super-admin/statement-processing/companies/${companyId}/addresses`,
    );
  }

  generateStatementImportAddress(companyId: string, label?: string) {
    return this.request<StatementImportAddressDto>(
      `/super-admin/statement-processing/companies/${companyId}/addresses`,
      { method: "POST", body: JSON.stringify({ label }) },
    );
  }

  regenerateStatementImportAddress(addressId: string) {
    return this.request<StatementImportAddressDto>(
      `/super-admin/statement-processing/addresses/${addressId}/regenerate`,
      { method: "POST" },
    );
  }

  getStatementProcessingStats(companyId: string) {
    return this.request<{ received: number; success: number; failed: number; duplicates: number; totalCost: string }>(
      `/super-admin/statement-processing/stats?companyId=${companyId}`,
    );
  }

  listStatementProcessingHistory(companyId: string) {
    return this.request<StatementProcessingHistoryDto[]>(
      `/super-admin/statement-processing/history?companyId=${companyId}`,
    );
  }

  listFcmDevicesForCompany(companyId: string) {
    return this.request<FcmDeviceDto[]>(`/super-admin/companies/${companyId}/fcm-devices`);
  }

  sendTestPushToDevice(companyId: string, deviceId: string, message?: { title: string; body: string }) {
    return this.request<{ success: boolean }>(
      `/super-admin/companies/${companyId}/fcm-devices/${deviceId}/test-push`,
      { method: "POST", body: JSON.stringify(message ?? {}) },
    );
  }

  getDeviceDetail(companyId: string, deviceId: string) {
    return this.request<FcmDeviceDetailDto>(`/super-admin/companies/${companyId}/fcm-devices/${deviceId}`);
  }

  listDeviceActivity(companyId: string, deviceId: string) {
    return this.request<DeviceActivityLogDto[]>(
      `/super-admin/companies/${companyId}/fcm-devices/${deviceId}/activity`,
    );
  }

  sendDeviceCommand(companyId: string, deviceId: string, command: DeviceCommand) {
    return this.request<{ commandId: string; queued?: boolean }>(
      `/super-admin/companies/${companyId}/fcm-devices/${deviceId}/command`,
      { method: "POST", body: JSON.stringify({ command }) },
    );
  }

  listDeviceModules(companyId: string, deviceId: string) {
    return this.request<DeviceModuleDto[]>(`/super-admin/companies/${companyId}/fcm-devices/${deviceId}/modules`);
  }

  setDeviceModule(companyId: string, deviceId: string, featureKey: string, allowed: boolean) {
    return this.request<{ fcmDeviceId: string; featureKey: string; allowed: boolean }>(
      `/super-admin/companies/${companyId}/fcm-devices/${deviceId}/modules/${featureKey}`,
      { method: "PATCH", body: JSON.stringify({ allowed }) },
    );
  }

  listMobileUsers(companyId: string) {
    return this.request<MobileUserAccessDto[]>(`/super-admin/companies/${companyId}/mobile-users`);
  }

  setUserMobileAccess(companyId: string, userId: string, mobileAppEnabled: boolean) {
    return this.request<{ userId: string; mobileAppEnabled: boolean }>(
      `/super-admin/companies/${companyId}/mobile-users/${userId}`,
      { method: "PATCH", body: JSON.stringify({ mobileAppEnabled }) },
    );
  }

  getMobileLicenseInfo(companyId: string) {
    return this.request<{ used: number; total: number | null }>(
      `/super-admin/companies/${companyId}/mobile-license-info`,
    );
  }

  getUserMobileModules(companyId: string, userId: string) {
    return this.request<{ moduleId: string; key: string; name: string; allowed: boolean }[]>(
      `/super-admin/companies/${companyId}/mobile-users/${userId}/modules`,
    );
  }

  setUserMobileModule(companyId: string, userId: string, moduleId: string, allowed: boolean) {
    return this.request<{ userId: string; moduleId: string; allowed: boolean }>(
      `/super-admin/companies/${companyId}/mobile-users/${userId}/modules/${moduleId}`,
      { method: "PATCH", body: JSON.stringify({ allowed }) },
    );
  }

  listServiceEndpoints() {
    return this.request<ServiceEndpointDto[]>("/super-admin/service-endpoints");
  }

  updateServiceEndpoint(key: string, payload: Partial<UpdateServiceEndpointPayload>) {
    return this.request<ServiceEndpointDto>(`/super-admin/service-endpoints/${key}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  testServiceEndpointConnection(key: string) {
    return this.request<{ success: boolean; httpStatus: number | null; responseMs: number; error: string | null }>(
      `/super-admin/service-endpoints/${key}/test-connection`,
      { method: "POST" },
    );
  }

  getSefStatusForDocument(salesDocumentId: string) {
    return this.request<{
      id: string;
      status: string;
      sefInvoiceId: string | null;
      rejectionReason: string | null;
      createdAt: string;
    } | null>(`/e-invoices/sef/for-document/${salesDocumentId}`);
  }

  refreshSefStatus(eInvoiceId: string) {
    return this.request(`/e-invoices/sef/${eInvoiceId}/refresh-status`, { method: "POST" });
  }

  cancelSefInvoice(eInvoiceId: string, cancelComment: string) {
    return this.request(`/e-invoices/sef/${eInvoiceId}/cancel`, {
      method: "POST",
      body: JSON.stringify({ cancelComment }),
    });
  }

  // --- Podešavanja kompanije ---------------------------------------------------
  getCompanySettings() {
    return this.request<CompanySettingsDto>("/company");
  }

  updateCompanySettings(payload: UpdateCompanySettingsPayload) {
    return this.request<CompanySettingsDto>("/company", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getSmtpSettings() {
    return this.request<SmtpSettingsDto>("/company/smtp");
  }

  updateSmtpSettings(payload: UpdateSmtpSettingsPayload) {
    return this.request<SmtpSettingsDto>("/company/smtp", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getPfrSettings() {
    return this.request<PfrSettingsDto>("/company/pfr");
  }

  updatePfrSettings(payload: UpdatePfrSettingsPayload) {
    return this.request<PfrSettingsDto>("/company/pfr", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getIpsPgwSettings() {
    return this.request<IpsPgwSettingsDto>("/company/ips-pgw");
  }

  updateIpsPgwSettings(payload: UpdateIpsPgwSettingsPayload) {
    return this.request<IpsPgwSettingsDto>("/company/ips-pgw", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  testIpsPgwConnection() {
    return this.request<{ success: true; tokenExpiryTime?: number }>("/company/ips-pgw/test-connection", {
      method: "POST",
    });
  }

  getOtpCardSettings() {
    return this.request<OtpCardSettingsDto>("/company/otp-card");
  }

  updateOtpCardSettings(payload: UpdateOtpCardSettingsPayload) {
    return this.request<OtpCardSettingsDto>("/company/otp-card", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getIntesaCardSettings() {
    return this.request<IntesaCardSettingsDto>("/company/intesa-card");
  }

  updateIntesaCardSettings(payload: UpdateIntesaCardSettingsPayload) {
    return this.request<IntesaCardSettingsDto>("/company/intesa-card", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getBexCourierSettings() {
    return this.request<BexCourierSettingsDto>("/company/bex-courier");
  }

  updateBexCourierSettings(payload: UpdateBexCourierSettingsPayload) {
    return this.request<BexCourierSettingsDto>("/company/bex-courier", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getShipmentNotificationSettings() {
    return this.request<ShipmentNotificationSettingsDto>("/company/shipment-notifications");
  }

  updateShipmentNotificationSettings(payload: { notifyOnDispatch?: boolean; notifyOnStatus?: boolean }) {
    return this.request<ShipmentNotificationSettingsDto>("/company/shipment-notifications", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  listAllShipments(all = false) {
    return this.request<ShipmentDto[]>(`/couriers/shipments${all ? "?all=true" : ""}`);
  }

  refreshShipments(shipmentId?: string) {
    return this.request<ShipmentDto[]>(shipmentId ? `/couriers/shipments/${shipmentId}/refresh` : "/couriers/shipments/refresh", {
      method: "POST",
    });
  }

  getCityExpressCourierSettings() {
    return this.request<CityExpressCourierSettingsDto>("/company/city-express-courier");
  }

  updateCityExpressCourierSettings(payload: UpdateCityExpressCourierSettingsPayload) {
    return this.request<CityExpressCourierSettingsDto>("/company/city-express-courier", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getPostaCourierSettings() {
    return this.request<PostaCourierSettingsDto>("/company/posta-courier");
  }

  updatePostaCourierSettings(payload: UpdatePostaCourierSettingsPayload) {
    return this.request<PostaCourierSettingsDto>("/company/posta-courier", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  listCouriers() {
    return this.request<CourierListItemDto[]>("/couriers");
  }

  listShipmentsForWarehouseOrder(warehouseIssueOrderId: string) {
    return this.request<ShipmentDto[]>(`/couriers/warehouse-issue-orders/${warehouseIssueOrderId}/shipments`);
  }

  dispatchShipment(warehouseIssueOrderId: string, courier: string, payload: DispatchShipmentPayload) {
    return this.request<ShipmentDto>(`/couriers/warehouse-issue-orders/${warehouseIssueOrderId}/shipments/${courier}`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  cancelShipment(shipmentId: string) {
    return this.request<ShipmentDto>(`/couriers/shipments/${shipmentId}`, { method: "DELETE" });
  }

  getShipmentLabelUrl(shipmentId: string, format: "THERMAL" | "A4", position: number) {
    return `${this.options.baseUrl}/couriers/shipments/${shipmentId}/label?format=${format}&position=${position}`;
  }

  getRaiffeisenCardSettings() {
    return this.request<RaiffeisenCardSettingsDto>("/company/raiffeisen-card");
  }

  updateRaiffeisenCardSettings(payload: UpdateRaiffeisenCardSettingsPayload) {
    return this.request<RaiffeisenCardSettingsDto>("/company/raiffeisen-card", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  async uploadPfrCertificate(file: File): Promise<PfrSettingsDto> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${this.options.baseUrl}/company/pfr/certificate`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Otpremanje sertifikata nije uspelo.",
          path: "/company/pfr/certificate",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as PfrSettingsDto;
  }

  /** Otpremi PDF potvrdu Poreske uprave (mejl o izradi sertifikata) - n8n izvuče PAK/lozinku i automatski ih podesi. */
  async parsePfrCertificateDocument(file: File): Promise<PfrCertificateParseResultDto> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${this.options.baseUrl}/company/pfr/certificate/parse`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Očitavanje dokumenta nije uspelo.",
          path: "/company/pfr/certificate/parse",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as PfrCertificateParseResultDto;
  }

  /**
   * Otpremi ZIP arhivu sertifikata (dobijenu od Poreske uprave, sadrži .p12/.pfx u više formata) i/ili
   * PDF potvrdu u jednom koraku - backend automatski izvuče .pfx iz ZIP-a i PAK/lozinku iz PDF-a (n8n).
   * Bar jedan od dva fajla mora biti prosleđen.
   */
  async uploadPfrCertificateBundle(files: {
    archive?: File;
    document?: File;
  }): Promise<PfrCertificateBundleResultDto> {
    const formData = new FormData();
    if (files.archive) formData.append("archive", files.archive);
    if (files.document) formData.append("document", files.document);
    const res = await fetch(`${this.options.baseUrl}/company/pfr/certificate-bundle`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Otpremanje sertifikata nije uspelo.",
          path: "/company/pfr/certificate-bundle",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as PfrCertificateBundleResultDto;
  }

  /**
   * "Prepoznaj kasu iz sertifikata" - pregled PRE povezivanja, NE upisuje ništa.
   * Puna implementacija po lokaciji - šalje se .pfx fajl konkretnog uređaja
   * (svaki uređaj ima SOPSTVENI sertifikat), ne čita se Company-level.
   */
  async previewFiscalDeviceIdentity(file: File, password: string): Promise<FiscalDeviceIdentityDto> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("password", password);
    const res = await fetch(`${this.options.baseUrl}/company/fiscal-devices/preview`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Očitavanje sertifikata nije uspelo.",
          path: "/company/fiscal-devices/preview",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as FiscalDeviceIdentityDto;
  }

  /** Registruje kasu sa priloženim .pfx sertifikatom - vidi RegisterFiscalDeviceInput. */
  async registerFiscalDevice(file: File, input: RegisterFiscalDeviceInput): Promise<FiscalDeviceDto> {
    const formData = new FormData();
    formData.append("file", file);
    if (input.password) formData.append("password", input.password);
    formData.append("apiKey", input.apiKey);
    if (input.businessLocationId) formData.append("businessLocationId", input.businessLocationId);
    if (input.fcmDeviceId) formData.append("fcmDeviceId", input.fcmDeviceId);
    if (input.name) formData.append("name", input.name);
    const res = await fetch(`${this.options.baseUrl}/company/fiscal-devices`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Registracija uređaja nije uspela.",
          path: "/company/fiscal-devices",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as FiscalDeviceDto;
  }

  listFiscalDevices() {
    return this.request<FiscalDeviceDto[]>("/company/fiscal-devices");
  }

  /** Ručna potvrda/promena poslovne lokacije za već registrovan uređaj. */
  assignFiscalDeviceLocation(id: string, businessLocationId: string) {
    return this.request<FiscalDeviceDto>(`/company/fiscal-devices/${id}/business-location`, {
      method: "PATCH",
      body: JSON.stringify({ businessLocationId }),
    });
  }

  listAppReleases() {
    return this.request<AppReleaseAdminDto[]>("/super-admin/app-releases");
  }

  saveAppRelease(platform: string, payload: AppReleaseSavePayload) {
    return this.request<AppReleaseAdminDto[]>(`/super-admin/app-releases/${platform}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  }

  deleteAppRelease(platform: string) {
    return this.request<AppReleaseAdminDto[]>(`/super-admin/app-releases/${platform}`, { method: "DELETE" });
  }

  getLoyaltyProgram() {
    return this.request<LoyaltyProgramDto>("/loyalty/program");
  }

  saveLoyaltyProgram(payload: Partial<LoyaltyProgramDto>) {
    return this.request<LoyaltyProgramDto>("/loyalty/program", { method: "PUT", body: JSON.stringify(payload) });
  }

  createLoyaltyRule(payload: LoyaltyStampRuleInput) {
    return this.request<LoyaltyStampRuleDto>("/loyalty/rules", { method: "POST", body: JSON.stringify(payload) });
  }

  updateLoyaltyRule(id: string, payload: LoyaltyStampRuleInput) {
    return this.request<LoyaltyStampRuleDto>(`/loyalty/rules/${id}`, { method: "PUT", body: JSON.stringify(payload) });
  }

  deleteLoyaltyRule(id: string) {
    return this.request<{ deleted: boolean }>(`/loyalty/rules/${id}`, { method: "DELETE" });
  }

  getHorecaSetup(businessLocationId?: string) {
    return this.request<{ zones: HorecaZoneDto[]; stations: HorecaStationDto[] }>(
      `/horeca/setup${businessLocationId ? `?businessLocationId=${encodeURIComponent(businessLocationId)}` : ""}`,
    );
  }

  createHorecaZone(payload: { business_location_id: string; name: string }) {
    return this.request<HorecaZoneDto>("/horeca/zones", { method: "POST", body: JSON.stringify(payload) });
  }

  updateHorecaZone(id: string, payload: { name?: string; is_active?: boolean }) {
    return this.request<HorecaZoneDto>(`/horeca/zones/${id}`, { method: "PUT", body: JSON.stringify(payload) });
  }

  deleteHorecaZone(id: string) {
    return this.request<{ deleted: boolean }>(`/horeca/zones/${id}`, { method: "DELETE" });
  }

  createHorecaTable(payload: { zone_id: string; label: string; seats?: number; shape?: string }) {
    return this.request<HorecaTableDto>("/horeca/tables", { method: "POST", body: JSON.stringify(payload) });
  }

  updateHorecaTable(id: string, payload: { label?: string; seats?: number; shape?: string; is_active?: boolean }) {
    return this.request<HorecaTableDto>(`/horeca/tables/${id}`, { method: "PUT", body: JSON.stringify(payload) });
  }

  deleteHorecaTable(id: string) {
    return this.request<{ deleted: boolean }>(`/horeca/tables/${id}`, { method: "DELETE" });
  }

  saveHorecaLayout(tables: { id: string; x: number; y: number }[]) {
    return this.request<{ saved: number }>("/horeca/tables/layout", { method: "PUT", body: JSON.stringify({ tables }) });
  }

  createHorecaStation(payload: { name: string; business_location_id?: string | null; category_ids?: string[]; output_mode?: string; printer_name?: string | null }) {
    return this.request<HorecaStationDto>("/horeca/stations", { method: "POST", body: JSON.stringify(payload) });
  }

  updateHorecaStation(id: string, payload: { name?: string; category_ids?: string[]; is_active?: boolean; output_mode?: string; printer_name?: string | null }) {
    return this.request<HorecaStationDto>(`/horeca/stations/${id}`, { method: "PUT", body: JSON.stringify(payload) });
  }

  getHorecaKitchen(stationId?: string) {
    const q = stationId ? `?stationId=${encodeURIComponent(stationId)}` : "";
    return this.request<{ tickets: HorecaKitchenTicketDto[] }>(`/horeca/kitchen${q}`);
  }

  setHorecaItemStatus(item_ids: string[], status: "SENT" | "PREPARING" | "READY" | "SERVED") {
    return this.request<{ updated: number }>("/horeca/items/status", { method: "POST", body: JSON.stringify({ item_ids, status }) });
  }

  deleteHorecaStation(id: string) {
    return this.request<{ deleted: boolean }>(`/horeca/stations/${id}`, { method: "DELETE" });
  }

  getHorecaStaff() {
    return this.request<HorecaStaffDto[]>("/horeca/staff");
  }

  saveHorecaStaff(userId: string, payload: { see_all: boolean; zone_ids?: string[]; table_ids?: string[] }) {
    return this.request<{ user_id: string }>(`/horeca/staff/${userId}`, { method: "PUT", body: JSON.stringify(payload) });
  }

  getHorecaWorkCurrent() {
    return this.request<{ session: HorecaWorkSessionDto | null }>("/horeca/work/current");
  }

  horecaClockIn() {
    return this.request<{ session: HorecaWorkSessionDto }>("/horeca/work/clock-in", { method: "POST", body: JSON.stringify({}) });
  }

  horecaClockOut() {
    return this.request<{ session: HorecaWorkSessionDto }>("/horeca/work/clock-out", { method: "POST", body: JSON.stringify({}) });
  }

  listHorecaPromotions() {
    return this.request<{ promotions: HorecaPromotionDto[] }>("/horeca/promotions");
  }

  createHorecaPromotion(payload: HorecaPromotionInput) {
    return this.request<HorecaPromotionDto>("/horeca/promotions", { method: "POST", body: JSON.stringify(payload) });
  }

  updateHorecaPromotion(id: string, payload: HorecaPromotionInput) {
    return this.request<HorecaPromotionDto>(`/horeca/promotions/${id}`, { method: "PUT", body: JSON.stringify(payload) });
  }

  deleteHorecaPromotion(id: string) {
    return this.request<{ deleted: boolean }>(`/horeca/promotions/${id}`, { method: "DELETE" });
  }

  listPosShifts(limit = 60) {
    return this.request<{ shifts: PosShiftDto[] }>(`/shifts?limit=${limit}`);
  }

  getPosShiftReport(id: string) {
    return this.request<PosShiftReportDto>(`/shifts/${id}/report`);
  }

  getHorecaWorkReport(params: { from: string; to: string }) {
    return this.request<HorecaWorkReportDto>(`/horeca/work/report?from=${params.from}&to=${params.to}`);
  }

  getHorecaKep(params: { from: string; to: string; businessLocationId?: string }) {
    const q = new URLSearchParams({ from: params.from, to: params.to });
    if (params.businessLocationId) q.set("businessLocationId", params.businessLocationId);
    return this.request<HorecaKepDto>(`/horeca/kep?${q.toString()}`);
  }

  getHorecaSalesReport(params: { from: string; to: string; businessLocationId?: string }) {
    const q = new URLSearchParams({ from: params.from, to: params.to });
    if (params.businessLocationId) q.set("businessLocationId", params.businessLocationId);
    return this.request<HorecaSalesReportDto>(`/horeca/reports/sales?${q.toString()}`);
  }

  getHorecaSchedule(params: { from: string; to: string }) {
    return this.request<{ plans: HorecaShiftPlanDto[] }>(`/horeca/schedule?from=${params.from}&to=${params.to}`);
  }

  saveHorecaSchedule(payload: { user_id: string; date: string; start_time: string; end_time: string; note?: string | null }) {
    return this.request<HorecaShiftPlanDto>("/horeca/schedule", { method: "PUT", body: JSON.stringify(payload) });
  }

  deleteHorecaSchedule(userId: string, date: string) {
    return this.request<{ deleted: number }>(`/horeca/schedule?userId=${encodeURIComponent(userId)}&date=${date}`, { method: "DELETE" });
  }

  getEotpSettings() {
    return this.request<{ has_key: boolean; key_hint: string | null; mode: "DEMO" | "PROD" }>("/eotpremnice/settings");
  }

  saveEotpSettings(payload: { api_key?: string; mode?: "DEMO" | "PROD" }) {
    return this.request<{ has_key: boolean; key_hint: string | null; mode: "DEMO" | "PROD" }>("/eotpremnice/settings", { method: "PUT", body: JSON.stringify(payload) });
  }

  eotpDefaults() {
    return this.request<{ actualDespatchAt: string; plannedDeliveryEndAt: string }>("/eotpremnice/defaults");
  }

  listEotpremnice() {
    return this.request<{ items: EotpremnicaDto[] }>("/eotpremnice");
  }

  getEotpremnica(id: string) {
    return this.request<EotpremnicaDto>(`/eotpremnice/${id}`);
  }

  saveEotpremnica(id: string | null, payload: { number?: string; data: EotpDataDto; sales_document_id?: string }) {
    return this.request<EotpremnicaDto>(id ? `/eotpremnice/${id}` : "/eotpremnice", { method: id ? "PUT" : "POST", body: JSON.stringify(payload) });
  }

  eotpremnicaFromDocument(salesDocumentId: string) {
    return this.request<EotpremnicaDto>(`/eotpremnice/from-document/${salesDocumentId}`, { method: "POST" });
  }

  deleteEotpremnica(id: string) {
    return this.request<{ success: boolean }>(`/eotpremnice/${id}`, { method: "DELETE" });
  }

  validateEotpremnica(id: string) {
    return this.request<EotpValidationDto>(`/eotpremnice/${id}/validate`, { method: "POST" });
  }

  sendEotpremnica(id: string) {
    return this.request<EotpremnicaDto>(`/eotpremnice/${id}/send`, { method: "POST" });
  }

  cancelEotpremnica(id: string, reason: string) {
    return this.request<EotpremnicaDto>(`/eotpremnice/${id}/cancel`, { method: "POST", body: JSON.stringify({ reason }) });
  }

  syncEotpremnice() {
    return this.request<{ updated: number }>("/eotpremnice/sync", { method: "POST" });
  }

  async downloadEotpremnicaBlobUrl(id: string, what: "xml" | "pdf"): Promise<string> {
    const res = await fetch(`${this.options.baseUrl}/eotpremnice/${id}/download/${what}`, { headers: { ...(this.options.getAuthHeaders?.() ?? {}) } });
    if (!res.ok) {
      if (res.status === 401) this.options.onUnauthorized?.();
      let msg = `Preuzimanje nije uspelo (HTTP ${res.status}).`;
      try { const j = await res.json(); if (typeof j?.message === "string") msg = j.message; } catch { /* ignore */ }
      throw new Error(msg);
    }
    return URL.createObjectURL(await res.blob());
  }

  listHorecaCounts() {
    return this.request<{ counts: HorecaCountDto[] }>("/horeca/counts");
  }

  createHorecaCount(payload: { warehouse_id: string; name?: string; only_ingredients?: boolean }) {
    return this.request<HorecaCountDto>("/horeca/counts", { method: "POST", body: JSON.stringify(payload) });
  }

  getHorecaCount(id: string) {
    return this.request<HorecaCountDto>(`/horeca/counts/${id}`);
  }

  saveHorecaCountLines(id: string, lines: { product_id: string; counted_qty: number | null }[]) {
    return this.request<HorecaCountDto>(`/horeca/counts/${id}/lines`, { method: "PUT", body: JSON.stringify({ lines }) });
  }

  applyHorecaCount(id: string) {
    return this.request<HorecaCountDto>(`/horeca/counts/${id}/apply`, { method: "POST" });
  }

  cancelHorecaCount(id: string) {
    return this.request<HorecaCountDto>(`/horeca/counts/${id}/cancel`, { method: "POST" });
  }

  getHorecaDpu(params: { date: string; businessLocationId?: string }) {
    const q = new URLSearchParams({ date: params.date });
    if (params.businessLocationId) q.set("businessLocationId", params.businessLocationId);
    return this.request<HorecaDpuDto>(`/horeca/dpu?${q.toString()}`);
  }

  getLoyaltyStats() {
    return this.request<LoyaltyStatsDto>("/loyalty/stats");
  }

  registerLoyaltyCustomer(payload: { name?: string; phone?: string; email?: string }) {
    return this.request<{ loyalty_id: string; name: string | null; phone: string | null; existing: boolean }>("/loyalty/customers", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  lookupLoyaltyCustomer(code: string) {
    return this.request<LoyaltyLookupDto>(`/loyalty/lookup?code=${encodeURIComponent(code)}`);
  }

  listMyDevices() {
    return this.request<CompanyDeviceDto[]>("/company-devices");
  }

  setMyDeviceBlocked(id: string, blocked: boolean) {
    return this.request<{ id: string; blocked: boolean }>(`/company-devices/${id}`, { method: "PATCH", body: JSON.stringify({ blocked }) });
  }

  setMyDeviceModule(id: string, featureKey: string, allowed: boolean) {
    return this.request<unknown>(`/company-devices/${id}/modules/${featureKey}`, { method: "PUT", body: JSON.stringify({ allowed }) });
  }

  listCompanyFcmDevices() {
    return this.request<CompanyFcmDeviceDto[]>("/company/fcm-devices");
  }

  async importProducts(format: "minimax", file: File): Promise<ProductImportSummaryDto> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${this.options.baseUrl}/products/import?format=${format}`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Uvoz artikala nije uspeo.",
          path: "/products/import",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as ProductImportSummaryDto;
  }

  async uploadCompanyLogo(file: File): Promise<CompanySettingsDto> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${this.options.baseUrl}/company/logo`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Otpremanje logoa nije uspelo.",
          path: "/company/logo",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as CompanySettingsDto;
  }

  // --- Prijem robe: magacin, dobavljači, ulaz robe -----------------------------
  listWarehouses() {
    return this.request<WarehouseDto[]>("/warehouses");
  }

  createWarehouse(payload: CreateWarehousePayload) {
    return this.request<WarehouseDto>("/warehouses", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateWarehouse(id: string, payload: UpdateWarehousePayload) {
    return this.request<WarehouseDto>(`/warehouses/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  listSuppliers(q?: string) {
    return this.request<SupplierDto[]>(q ? `/suppliers?q=${encodeURIComponent(q)}` : "/suppliers");
  }

  getSupplier(id: string) {
    return this.request<SupplierDto>(`/suppliers/${id}`);
  }

  createSupplier(payload: CreateSupplierPayload) {
    return this.request<SupplierDto>("/suppliers", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateSupplier(id: string, payload: UpdateSupplierPayload) {
    return this.request<SupplierDto>(`/suppliers/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  archiveSupplier(id: string) {
    return this.request<SupplierDto>(`/suppliers/${id}/archive`, { method: "POST" });
  }


  listPurchaseInvoices(params?: Record<string, string>) {
    const qs = params ? "?" + new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString() : "";
    return this.request<PurchaseInvoiceItem[]>(`/purchase-invoices${qs}`);
  }
  syncPurchaseInvoices(range?: { from: string; to: string }) {
    return this.request<{ totalFound: number; imported: number; failed: number; autoRejected?: number; remaining: number }>("/purchase-invoices/sync", {
      method: "POST",
      body: JSON.stringify(range ?? {}),
    });
  }
  importPurchaseInvoiceXml(xml: string) {
    return this.request<Record<string, unknown>>("/purchase-invoices/import-xml", { method: "POST", body: JSON.stringify({ xml }) });
  }
  purchaseInvoiceStatusCounts() {
    return this.request<Record<string, number>>("/purchase-invoices/status-counts");
  }
  getPurchaseInvoiceSettings() {
    return this.request<{ autoExpense: boolean }>("/purchase-invoices/settings");
  }
  setPurchaseInvoiceAutoExpense(enabled: boolean) {
    return this.request<{ autoExpense: boolean }>("/purchase-invoices/settings/auto-expense", { method: "POST", body: JSON.stringify({ enabled }) });
  }
  getPurchaseInvoice(id: string) {
    return this.request<PurchaseInvoiceDetail>(`/purchase-invoices/${id}`);
  }
  decidePurchaseInvoice(id: string, payload: { accepted: boolean; comment?: string; alwaysReject?: boolean; matchText?: string; onlySupplier?: boolean }) {
    return this.request<Record<string, unknown>>(`/purchase-invoices/${id}/decision`, { method: "POST", body: JSON.stringify(payload) });
  }
  listSefAutoRejectRules() {
    return this.request<SefAutoRejectRuleDto[]>("/purchase-invoices/auto-reject-rules");
  }
  saveSefAutoRejectRule(payload: { supplierTaxId?: string; matchText?: string; reason: string }) {
    return this.request<SefAutoRejectRuleDto>("/purchase-invoices/auto-reject-rules", { method: "POST", body: JSON.stringify(payload) });
  }
  applySefAutoRejectRules() {
    return this.request<{ rejected: number; matched: number; remaining?: number }>("/purchase-invoices/auto-reject-rules/apply", { method: "POST" });
  }
  deleteSefAutoRejectRule(id: string) {
    return this.request<{ deleted: boolean }>(`/purchase-invoices/auto-reject-rules/${id}`, { method: "DELETE" });
  }
  markPurchaseInvoiceExpense(id: string) {
    return this.request<Record<string, unknown>>(`/purchase-invoices/${id}/expense`, { method: "POST" });
  }
  unmarkPurchaseInvoiceExpense(id: string) {
    return this.request<Record<string, unknown>>(`/purchase-invoices/${id}/expense`, { method: "DELETE" });
  }
  listCalculations(params?: Record<string, string>) {
    const qs = params ? "?" + new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString() : "";
    return this.request<CalcListResponse>(`/calculations${qs}`);
  }
  getCalculation(id: string) {
    return this.request<CalcDto>(`/calculations/${id}`);
  }
  previewCalculation(payload: CalcInputPayload) {
    return this.request<CalcPreviewDto>("/calculations/preview", { method: "POST", body: JSON.stringify(payload) });
  }
  createCalculation(payload: CalcInputPayload) {
    return this.request<CalcDto>("/calculations", { method: "POST", body: JSON.stringify(payload) });
  }
  updateCalculation(id: string, payload: CalcInputPayload) {
    return this.request<CalcDto>(`/calculations/${id}`, { method: "PUT", body: JSON.stringify(payload) });
  }
  deleteCalculation(id: string) {
    return this.request<{ deleted: boolean }>(`/calculations/${id}`, { method: "DELETE" });
  }
  calculationAction(id: string, action: "check" | "submit" | "approve" | "post" | "duplicate") {
    return this.request<CalcDto>(`/calculations/${id}/${action}`, { method: "POST" });
  }
  sefPurchaseStatus() {
    return this.request<{ hasApiKey: boolean; mode: string; cached: number }>("/calculations/sef/status");
  }
  sefPurchaseSync() {
    return this.request<{ totalFound: number; imported: number; failed: number; remaining: number }>("/calculations/sef/sync", { method: "POST" });
  }
  sefPurchaseSearch(q?: string) {
    return this.request<SefInvoiceItem[]>(`/calculations/sef/invoices${q ? `?q=${encodeURIComponent(q)}` : ""}`);
  }
  sefPurchaseImportXml(xml: string) {
    return this.request<SefInvoiceItem>("/calculations/sef/import-xml", { method: "POST", body: JSON.stringify({ xml }) });
  }
  sefPurchaseDraft(id: string) {
    return this.request<CalcInputPayload & { supplierName?: string | null; invoiceTotals?: unknown }>(`/calculations/sef/invoices/${id}/draft`);
  }

  listGoodsReceipts() {
    return this.request<GoodsReceiptDto[]>("/goods-receipts");
  }

  getGoodsReceipt(id: string) {
    return this.request<GoodsReceiptDto>(`/goods-receipts/${id}`);
  }

  createGoodsReceipt(payload: CreateGoodsReceiptPayload) {
    return this.request<GoodsReceiptDto>("/goods-receipts", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  getStockLevels() {
    return this.request<StockLevelDto[]>("/goods-receipts/stock");
  }

  // --- Autentifikacija i korisnici --------------------------------------------
  login(payload: LoginPayload) {
    return this.request<LoginResponseDto>("/auth/login", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  getMe() {
    return this.request<UserDto>("/auth/me");
  }

  listUsers() {
    return this.request<UserDto[]>("/users");
  }

  createUser(payload: CreateUserPayload) {
    return this.request<UserDto>("/users", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateUser(id: string, payload: UpdateUserPayload) {
    return this.request<UserDto>(`/users/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  // NFC kartica login (Finora Mobile) - vidi "Dopuna specifikacije"
  // 25.09.2026. cardSerial se salje TACNO kako ga UI unese - backend sam
  // normalizuje (trim+uppercase) pre poredjenja/hesovanja.
  assignEmployeeCard(id: string, payload: { cardSerial: string; pin: string }) {
    return this.request<{ message: string }>(`/users/${id}/card`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  removeEmployeeCard(id: string) {
    return this.request<{ message: string }>(`/users/${id}/card`, {
      method: "DELETE",
    });
  }

  signup(payload: SignupPayload) {
    return this.request<SignupResponseDto>("/auth/signup", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  confirmAccount(payload: ConfirmAccountPayload) {
    return this.request<LoginResponseDto>("/auth/confirm-account", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  forgotPassword(payload: ForgotPasswordPayload) {
    return this.request<MessageResponseDto>("/auth/forgot-password", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  resetPassword(payload: ResetPasswordPayload) {
    return this.request<MessageResponseDto>("/auth/reset-password", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  changePassword(payload: ChangePasswordPayload) {
    return this.request<MessageResponseDto>("/auth/change-password", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  requestOtp(payload: OtpRequestPayload) {
    return this.request<MessageResponseDto>("/auth/otp/request", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  verifyOtp(payload: OtpVerifyPayload) {
    return this.request<LoginResponseDto>("/auth/otp/verify", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  /** Onboarding "Kompanija" korak - KREIRA firmu za korisnika bez firme (vidi CompanyStep.tsx). */
  createCompanyOnboarding(payload: OnboardingCreateCompanyPayload) {
    return this.request<OnboardingCreateCompanyResponseDto>("/company/onboarding", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  // --- Finora Admin: Email (SMTP) i template-i --------------------------------
  getPlatformMailSettings() {
    return this.request<PlatformMailSettingsDto>("/super-admin/mail/settings");
  }

  updatePlatformMailSettings(payload: UpdatePlatformMailSettingsPayload) {
    return this.request<PlatformMailSettingsDto>("/super-admin/mail/settings", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  sendTestMail(to: string) {
    return this.request<{ success: boolean }>("/super-admin/mail/settings/test", {
      method: "POST",
      body: JSON.stringify({ to }),
    });
  }

  listEmailTemplates() {
    return this.request<EmailTemplateDto[]>("/super-admin/mail/templates");
  }

  getEmailTemplate(key: EmailTemplateKey) {
    return this.request<EmailTemplateDto>(`/super-admin/mail/templates/${key}`);
  }

  updateEmailTemplate(key: EmailTemplateKey, payload: UpdateEmailTemplatePayload) {
    return this.request<EmailTemplateDto>(`/super-admin/mail/templates/${key}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  previewEmailTemplate(key: EmailTemplateKey) {
    return this.request<EmailTemplatePreviewDto>(`/super-admin/mail/templates/${key}/preview`, {
      method: "POST",
    });
  }

  resetEmailTemplate(key: EmailTemplateKey) {
    return this.request<EmailTemplateDto>(`/super-admin/mail/templates/${key}/reset`, {
      method: "POST",
    });
  }

  listAllCompanies() {
    return this.request<CompanyAdminDto[]>("/super-admin/companies");
  }

  createCompanyAsAdmin(payload: CreateCompanyAsAdminPayload) {
    return this.request<LoginResponseDto>("/super-admin/companies", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  setCompanyActive(id: string, isActive: boolean) {
    return this.request<CompanyAdminDto>(`/super-admin/companies/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ isActive }),
    });
  }

  getCompanyStats(id: string) {
    return this.request<CompanyStatsDto>(`/super-admin/companies/${id}/stats`);
  }

  updateCompanyProfileAdmin(id: string, payload: UpdateCompanyProfileAdminPayload) {
    return this.request<CompanyAdminDto>(`/super-admin/companies/${id}/profile`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  listCompanyUsersAdmin(companyId: string) {
    return this.request<CompanyUserAdminDto[]>(`/super-admin/companies/${companyId}/users`);
  }

  updateCompanyUserAdmin(
    companyId: string,
    userId: string,
    payload: { fullName?: string; email?: string; password?: string; isActive?: boolean },
  ) {
    return this.request<CompanyUserAdminDto>(`/super-admin/companies/${companyId}/users/${userId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  sendCompanyUserPasswordResetAdmin(companyId: string, userId: string) {
    return this.request<{ kind: "reset" | "verification" }>(
      `/super-admin/companies/${companyId}/users/${userId}/send-password-reset`,
      { method: "POST" },
    );
  }

  getMyGmailImport() {
    return this.request<GmailImportDto | null>(`/izvodi/gmail`);
  }

  saveMyGmailImport(
    body: {
      provider?: "GMAIL" | "IMAP";
      gmailAddress: string;
      appPassword?: string;
      imapHost?: string;
      imapPort?: number;
      imapSecure?: boolean;
      imapUser?: string;
      subjectFilters?: string[];
      sinceDate: string;
      isActive?: boolean;
    },
  ) {
    return this.request<GmailImportDto>(`/izvodi/gmail`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  }

  testMyGmailImport() {
    return this.request<{ ok: boolean; matched?: number; sample?: string[]; error?: string }>(
      `/izvodi/gmail/test`,
      { method: "POST" },
    );
  }

  runMyGmailImport() {
    return this.request<{ started: boolean }>(`/izvodi/gmail/run`, { method: "POST" });
  }

  deleteMyGmailImport() {
    return this.request<{ ok: boolean }>(`/izvodi/gmail`, { method: "DELETE" });
  }

  getWooConnector() {
    return this.request<WooConnectorDto | null>("/woo-connector");
  }

  saveWooConnector(body: {
    siteUrl: string;
    mode: "PLUGIN" | "WC_KEYS";
    token?: string;
    consumerKey?: string;
    consumerSecret?: string;
    isActive?: boolean;
    pricesNet?: boolean;
  }) {
    return this.request<WooConnectorDto>("/woo-connector", { method: "PUT", body: JSON.stringify(body) });
  }

  testWooConnector(code?: string) {
    return this.request<{
      ok: boolean;
      info?: string;
      error?: string;
      sample?: { name: string; price: string; sku: string } | null;
      sampleSearched?: boolean;
    }>("/woo-connector/test", { method: "POST", body: JSON.stringify({ code }) });
  }

  deleteWooConnector() {
    return this.request<{ ok: boolean }>("/woo-connector", { method: "DELETE" });
  }

  /** Kasa: naziv i cena artikla sa WooCommerce sajta (enabled=false kad konektor nije uključen). */
  lookupWooProduct(code: string) {
    return this.request<{ enabled: boolean; found: boolean; name?: string; price?: string; sku?: string; error?: string }>(
      `/woo-connector/lookup?code=${encodeURIComponent(code)}`,
    );
  }

  /** Kasa: šifra nije u HAFiskalu -> napravi artikal sa podacima sa WooCommerce sajta. */
  importWooProduct(code: string) {
    return this.request<{ created: boolean; product: ProductDto | null; message?: string }>(`/woo-connector/import-product`, {
      method: "POST",
      body: JSON.stringify({ code }),
    });
  }

  listCompanyInvoicesAdmin(companyId: string) {
    return this.request<CompanyInvoicesAdminDto>(`/super-admin/companies/${companyId}/invoices`);
  }

  /**
   * Super-admin ekran "Logovi" (28.09.2026) - fiskalizacija/Cloud API/uvoz
   * izvoda preko SVIH firmi, sa nazivom klijenta uz svaki red, da bi se
   * greske mogle pratiti po klijentu na jednom mestu.
   */
  listFiscalizationLogsAdmin(params?: { limit?: number; onlyFailed?: boolean }) {
    const qs = new URLSearchParams();
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.onlyFailed) qs.set("onlyFailed", "1");
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<FiscalizationLogEntryDto[]>(`/super-admin/logs/fiscalization${suffix}`);
  }

  listCloudApiLogsAdmin(params?: { limit?: number; onlyErrors?: boolean }) {
    const qs = new URLSearchParams();
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.onlyErrors) qs.set("onlyErrors", "1");
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<CloudApiLogEntryDto[]>(`/super-admin/logs/cloud-api${suffix}`);
  }

  listBankStatementImportLogsAdmin(params?: { limit?: number; onlyFailed?: boolean }) {
    const qs = new URLSearchParams();
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.onlyFailed) qs.set("onlyFailed", "1");
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<BankStatementImportLogEntryDto[]>(`/super-admin/logs/bank-statement-imports${suffix}`);
  }

  listMobileLogsAdmin(params?: { limit?: number; onlyErrors?: boolean }) {
    const qs = new URLSearchParams();
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.onlyErrors) qs.set("onlyErrors", "1");
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<MobileLogEntryDto[]>(`/super-admin/logs/mobile${suffix}`);
  }

  listSefLogsAdmin(params?: { limit?: number; onlyErrors?: boolean }) {
    const qs = new URLSearchParams();
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.onlyErrors) qs.set("onlyErrors", "1");
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<SefApiLogEntryDto[]>(`/super-admin/logs/sef${suffix}`);
  }

  listCourierLogsAdmin(params?: { limit?: number; onlyErrors?: boolean }) {
    const qs = new URLSearchParams();
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.onlyErrors) qs.set("onlyErrors", "1");
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<CourierApiLogEntryDto[]>(`/super-admin/logs/couriers${suffix}`);
  }

  listPfrLogsAdmin(params?: { limit?: number; fiscalDocumentId?: string }) {
    const qs = new URLSearchParams();
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.fiscalDocumentId) qs.set("fiscalDocumentId", params.fiscalDocumentId);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<PfrResponseLogEntryDto[]>(`/super-admin/logs/pfr${suffix}`);
  }

  listAllUsers(onlyUnverified?: boolean) {
    const qs = onlyUnverified ? "?unverified=1" : "";
    return this.request<PlatformUserAdminDto[]>(`/super-admin/users${qs}`);
  }

  resendUserVerificationEmail(userId: string) {
    return this.request<void>(`/super-admin/users/${userId}/resend-verification`, {
      method: "POST",
    });
  }

  listSystemApiKeys() {
    return this.request<SystemApiKeyDto[]>("/super-admin/system-api-key");
  }

  generateSystemApiKey(label: string) {
    return this.request<{ rawKey: string; keyPrefix: string }>("/super-admin/system-api-key", {
      method: "POST",
      body: JSON.stringify({ label }),
    });
  }

  revokeSystemApiKey(id: string) {
    return this.request<void>(`/super-admin/system-api-key/${id}`, { method: "DELETE" });
  }

  listAdminModules() {
    return this.request<AdminModuleDto[]>("/super-admin/modules");
  }

  listModuleGroups() {
    return this.request<ModuleGroupDto[]>("/super-admin/module-groups");
  }

  createModuleGroup(name: string, description?: string | null) {
    return this.request<ModuleGroupDto>("/super-admin/module-groups", {
      method: "POST",
      body: JSON.stringify({ name, description }),
    });
  }

  listModules() {
    return this.request<ModuleDto[]>("/super-admin/modules");
  }

  listPackages() {
    return this.request<PackageDto[]>("/super-admin/packages");
  }

  createPackage(payload: {
    key: string;
    name: string;
    price: string;
    billingPeriod?: "MONTHLY" | "YEARLY";
    trialEnabled?: boolean;
    trialDurationDays?: number;
    includedUsers?: number;
    additionalUserPrice?: string;
    additionalWarehousePrice?: string;
    family?: "ERP" | "API";
  }) {
    return this.request<PackageDto>("/super-admin/packages", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updatePackage(id: string, payload: Partial<PackageDto>) {
    return this.request<PackageDto>(`/super-admin/packages/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  setPackageModule(packageId: string, moduleId: string, included: boolean) {
    return this.request<{ packageId: string; moduleId: string; included: boolean }>(
      `/super-admin/packages/${packageId}/modules/${moduleId}`,
      { method: "PATCH", body: JSON.stringify({ included }) },
    );
  }

  // --- "Moj paket" (tenant-scoped, vidi razgovor) --------------------------

  getMyPackage() {
    return this.request<{
      current: {
        packageId: string;
        packageName: string;
        packageKey: string;
        price: string;
        priceGross: string;
        billingPeriod: "MONTHLY" | "YEARLY";
        status: string;
        currentPeriodStart: string;
        currentPeriodEnd: string;
        trialEndsAt: string | null;
      } | null;
      packages: Array<{
        id: string;
        key: string;
        name: string;
        price: string;
        priceGross: string;
        billingPeriod: "MONTHLY" | "YEARLY";
        trialEnabled: boolean;
        trialDurationDays: number | null;
        includedUsers: number;
        additionalUserPrice: string;
        additionalUserPriceGross: string;
        includedModules: Array<{ id: string; key: string; name: string; description: string | null }>;
        isCurrent: boolean;
        family: "ERP" | "API";
      }>;
      // Dodato uz redizajn "Moj paket" stranice (22.09.2026) - katalog
      // samostalnih addon modula (Module.addonAvailable) sa cenom i da li je
      // već aktivan za firmu (deo trenutnog paketa ili kupljen posebno).
      addonModules: Array<{
        id: string;
        key: string;
        name: string;
        description: string | null;
        price: string;
        priceGross: string;
        isActive: boolean;
        billingType: string;
        requiredModules: Array<{ key: string; name: string }>;
      }>;
      activeModules: Array<{ key: string; name: string }>;
      // Poreska stopa MATIČNE Finora firme (izdavaoca ponude) korišćena za
      // priceGross/additionalUserPriceGross iznad - vidi
      // SalesDocumentsService.getOwnerTaxRatePercent (23.09.2026).
      taxRatePercent: string;
    }>("/company/subscription");
  }

  /** Generiše ponudu za prelazak na drugi paket (isto kao ručno kreirana ponuda) - vidi SalesDocumentDto. */
  changePackage(packageId: string) {
    return this.request<SalesDocumentDto>("/company/subscription/change-package", {
      method: "POST",
      body: JSON.stringify({ packageId }),
    });
  }

  /** Onboarding - instant aktivacija besplatnog probnog paketa (npr. Starter). */
  startTrial(packageId: string) {
    return this.request<{
      current: {
        packageId: string;
        packageName: string;
        packageKey: string;
        price: string;
        billingPeriod: "MONTHLY" | "YEARLY";
        status: string;
        currentPeriodStart: string;
        currentPeriodEnd: string;
        trialEndsAt: string | null;
      } | null;
      packages: unknown[];
    }>("/company/subscription/start-trial", {
      method: "POST",
      body: JSON.stringify({ packageId }),
    });
  }

  /**
   * "Aktiviraj dodatak" - generiše ponudu za samostalnu kupovinu jednog
   * addon modula (npr. MiniMax), vidi ModuleGateNotice komponentu i
   * SalesDocumentsService.createAddonPurchaseQuote.
   */
  purchaseAddon(moduleKey: string, alsoOrdering: string[] = []) {
    return this.request<SalesDocumentDto>("/company/subscription/purchase-addon", {
      method: "POST",
      body: JSON.stringify({ moduleKey, alsoOrdering }),
    });
  }

  /**
   * "+1 magacin" - generiše ponudu za kupovinu jednog dodatnog magacina
   * preko uključenog broja (isti obrazac kao purchaseAddon), vidi
   * WarehousesTab "+" dugme i SalesDocumentsService.createExtraWarehouseQuote.
   */
  purchaseExtraWarehouse() {
    return this.request<SalesDocumentDto>("/company/subscription/purchase-warehouse", {
      method: "POST",
    });
  }

  /**
   * "+1 korisničko mesto" - generiše ponudu za kupovinu jednog dodatnog
   * korisničkog mesta preko uključenog broja, vidi AdminUsersPage "+"
   * dugme i SalesDocumentsService.createExtraUserSeatQuote.
   */
  purchaseExtraUserSeat() {
    return this.request<SalesDocumentDto>("/company/subscription/purchase-user-seat", {
      method: "POST",
    });
  }

  /**
   * Proaktivan pregled entitlement-a (aktivni moduli + limiti/cene
   * magacina i korisnika) - vidi EntitlementsController. Koristi se npr.
   * da se tab "Otpremnice" sakrije kad "magacin" modul nije aktivan, bez
   * čekanja na reaktivnu 403 grešku.
   */
  getEntitlements() {
    return this.request<EntitlementsSummaryDto>("/company/entitlements");
  }

  /** Onboarding, korak "Kompanija" - traži podatke firme po PIB-u (CompanyWall preko n8n). */
  lookupCompanyByPib(pib: string) {
    return this.request<{
      name: string;
      pib: string;
      registrationNumber: string | null;
      address: string | null;
      activityCode: string | null;
      activityName: string | null;
      status: string | null;
      foundedAt: string | null;
      owner: string | null;
      phone: string | null;
      email: string | null;
      street: string | null;
      houseNumber: string | null;
      postalCode: string | null;
      city: string | null;
      bankAccounts: { accountNumber: string; bankName: string | null; status: string | null; openedAt: string | null }[];
    }>("/company/lookup-pib", {
      method: "POST",
      body: JSON.stringify({ pib }),
    });
  }

  /** "Moji računi" - ponude/fakture koje je DRUGA Finora firma (najčešće matična) izdala ovoj firmi. */
  getMyInvoices() {
    return this.request<MyInvoicesResponseDto>("/company/my-invoices");
  }

  updateModuleEntitlement(
    moduleId: string,
    payload: { addonAvailable?: boolean; addonPrice?: string | null; minimumPackageId?: string | null; requiredModuleKeys?: string[] },
  ) {
    return this.request<void>(`/super-admin/modules/${moduleId}/entitlement`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  setModuleGroupPrice(groupId: string, moduleId: string, billingType: string, price: string) {
    return this.request<void>(`/super-admin/module-groups/${groupId}/prices/${moduleId}`, {
      method: "PATCH",
      body: JSON.stringify({ billingType, price }),
    });
  }

  getCompanyModules(companyId: string) {
    return this.request<CompanyModuleDto[]>(`/super-admin/companies/${companyId}/modules`);
  }

  /** Za web Sidebar (bez mobile-specifičnih dodatnih provera) - vidi getMyCompanyModules za mobile varijantu. */
  getMyCompanyModulesForWeb() {
    return this.request<{ modules: { key: string; name: string; status: string }[] }>("/company/modules/web");
  }

  /** Self-service verzija (JWT odredjuje companyId) - Finora Mobile varijanta (ima dodatnu proveru per-user pristupa). */
  getMyCompanyModules() {
    return this.request<{ modules: { key: string; name: string; status: string }[] }>("/company/modules");
  }

  setCompanyModule(
    companyId: string,
    moduleId: string,
    payload: {
      status: string;
      overrideBillingType?: string | null;
      overridePrice?: string | null;
      trialUntil?: string | null;
      licenseCount?: number | null;
    },
  ) {
    // Vraća AŽURIRAN red (isti oblik kao getCompanyModules) - frontend ga
    // upisuje direktno u react-query keš, bez refetch-a/reload-a (vidi
    // ModuliTab u CompanyDetailPage.tsx).
    return this.request<CompanyModuleDto>(`/super-admin/companies/${companyId}/modules/${moduleId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getCompanySubscriptionAdmin(companyId: string) {
    return this.request<CompanySubscriptionAdminDto>(`/super-admin/companies/${companyId}/subscription`);
  }

  setCompanySubscriptionAdmin(companyId: string, packageId: string) {
    return this.request<{ success: boolean; subscriptionId: string }>(
      `/super-admin/companies/${companyId}/subscription`,
      { method: "PATCH", body: JSON.stringify({ packageId }) },
    );
  }

  setCompanySubscriptionStatusAdmin(companyId: string, status: string) {
    return this.request<{ success: boolean; status: string }>(
      `/super-admin/companies/${companyId}/subscription/status`,
      { method: "PATCH", body: JSON.stringify({ status }) },
    );
  }

  setCompanyBillingGroup(companyId: string, billingGroupId: string | null) {
    return this.request<{ success: boolean }>(`/super-admin/companies/${companyId}/billing-group`, {
      method: "PATCH",
      body: JSON.stringify({ billingGroupId }),
    });
  }

  getCompanyUsage(companyId: string, from?: string, to?: string) {
    const params = new URLSearchParams();
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    const qs = params.toString();
    return this.request<CompanyUsageDto>(`/super-admin/companies/${companyId}/usage${qs ? `?${qs}` : ""}`);
  }

  listAdminAuditLog(targetType?: string, targetId?: string) {
    const params = new URLSearchParams();
    if (targetType) params.set("targetType", targetType);
    if (targetId) params.set("targetId", targetId);
    const qs = params.toString();
    return this.request<AdminAuditLogDto[]>(`/super-admin/audit-log${qs ? `?${qs}` : ""}`);
  }

  // --- Cloud API: integracije, API ključevi, webhookovi, mrežni uređaji -------
  listCloudApiIntegrations() {
    return this.request<CloudApiIntegrationDto[]>("/cloud-api/integrations");
  }

  createCloudApiIntegration(payload: CreateCloudApiIntegrationPayload) {
    return this.request<CloudApiIntegrationDto>("/cloud-api/integrations", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  disableCloudApiIntegration(id: string) {
    return this.request<void>(`/cloud-api/integrations/${id}/disable`, { method: "POST" });
  }

  enableCloudApiIntegration(id: string) {
    return this.request<void>(`/cloud-api/integrations/${id}/enable`, { method: "POST" });
  }

  updateCloudApiIntegrationLocation(id: string, businessLocationId: string | null) {
    return this.request<CloudApiIntegrationDto>(`/cloud-api/integrations/${id}/business-location`, {
      method: "PATCH",
      body: JSON.stringify({ businessLocationId }),
    });
  }

  createCloudApiKey(integrationId: string) {
    return this.request<CloudApiNewKeyDto>(`/cloud-api/integrations/${integrationId}/api-keys`, {
      method: "POST",
    });
  }

  rotateCloudApiKey(integrationId: string, apiKeyId: string) {
    return this.request<CloudApiNewKeyDto>(
      `/cloud-api/integrations/${integrationId}/api-keys/${apiKeyId}/rotate`,
      { method: "POST" },
    );
  }

  revokeCloudApiKey(integrationId: string, apiKeyId: string) {
    return this.request<void>(`/cloud-api/integrations/${integrationId}/api-keys/${apiKeyId}`, {
      method: "DELETE",
    });
  }

  deleteCloudApiIntegration(integrationId: string) {
    return this.request<void>(`/cloud-api/integrations/${integrationId}`, { method: "DELETE" });
  }

  deleteCloudApiKey(integrationId: string, apiKeyId: string) {
    return this.request<void>(
      `/cloud-api/integrations/${integrationId}/api-keys/${apiKeyId}/permanently`,
      { method: "DELETE" },
    );
  }

  // --- Print Agent - vidi "Finora - Print Agent API" spec, tačka 8 -----------
  listPrintAgents(includeRevoked = false) {
    const qs = includeRevoked ? "?include_revoked=1" : "";
    return this.request<PrintAgentListItemDto[]>(`/print-agents${qs}`);
  }

  getPrintAgentConnection(id: string) {
    return this.request<PrintAgentConnectionDto>(`/print-agents/${id}/connection`);
  }

  renamePrintAgent(id: string, name: string) {
    return this.request<{ id: string; name: string }>(`/print-agents/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ name }),
    });
  }

  revokePrintAgent(id: string) {
    return this.request<{ success: boolean }>(`/print-agents/${id}`, { method: "DELETE" });
  }

  assignPrintAgentLocation(id: string, businessLocationId: string | null) {
    return this.request<{ id: string; business_location_id: string | null }>(
      `/print-agents/${id}/business-location`,
      { method: "PATCH", body: JSON.stringify({ businessLocationId }) },
    );
  }

  listPrintAgentKeys() {
    return this.request<PrintAgentKeyDto[]>("/print-agent-keys");
  }

  createPrintAgentKey(label?: string) {
    return this.request<PrintAgentNewKeyDto>("/print-agent-keys", {
      method: "POST",
      body: JSON.stringify({ label: label || undefined }),
    });
  }

  revokePrintAgentKey(id: string) {
    return this.request<{ success: boolean }>(`/print-agent-keys/${id}`, { method: "DELETE" });
  }

  adminCompanyLicences(companyId: string) {
    return this.request<{
      lpfr: Array<{ id: string; label: string | null; key_prefix: string; key: string | null; created_at: string; last_used_at: string | null }>;
      kasa: Array<{ id: string; label: string | null; key_prefix: string; key: string | null; created_at: string; last_used_at: string | null }>;
      installations: Array<{ jid: string | null; invoices: number; last_at: string }>;
    }>(`/super-admin/lpfr/company/${encodeURIComponent(companyId)}/licences`);
  }

  getKasaPaketi() {
    return this.request<KasaPaketiOverviewDto>("/company/kasa-paketi");
  }
  updateKasaPaket(id: string, body: { label?: string; businessLocationId?: string | null }) {
    return this.request<{ success: boolean }>(`/company/kasa-paketi/${id}`, { method: "PATCH", body: JSON.stringify(body) });
  }
  releaseKasaPaket(id: string) {
    return this.request<{ success: boolean }>(`/company/kasa-paketi/${id}/release`, { method: "POST" });
  }
  adminListKasaPaketi(companyId: string) {
    return this.request<KasaPaketDto[]>(`/super-admin/kasa-paketi?companyId=${encodeURIComponent(companyId)}`);
  }
  adminCreateKasaPaket(body: { companyId: string; kind: "OBICNA" | "HORECA"; label?: string; months?: number }) {
    return this.request<{ id: string }>("/super-admin/kasa-paketi", { method: "POST", body: JSON.stringify(body) });
  }
  adminBindKasaPaketJid(id: string, jid: string | null) {
    return this.request<{ success: boolean }>(`/super-admin/kasa-paketi/${id}/jid`, { method: "PATCH", body: JSON.stringify({ jid }) });
  }
  adminRevokeKasaPaket(id: string) {
    return this.request<{ success: boolean }>(`/super-admin/kasa-paketi/${id}`, { method: "DELETE" });
  }

  getLpfrOverview() {
    return this.request<LpfrOverviewDto>("/company/lpfr-overview");
  }

  listLpfrLicenses() {
    return this.request<PrintAgentKeyDto[]>("/lpfr-licenses");
  }
  createLpfrLicense(label?: string) {
    return this.request<PrintAgentNewKeyDto>("/lpfr-licenses", {
      method: "POST",
      body: JSON.stringify({ label: label || undefined }),
    });
  }
  revokeLpfrLicense(id: string) {
    return this.request<{ success: boolean }>(`/lpfr-licenses/${id}`, { method: "DELETE" });
  }

  // --- Print Agent - Super Admin, cross-company (spec, tačka 8.4) ------------
  listAllPrintAgentsAdmin() {
    return this.request<PrintAgentAdminListItemDto[]>("/super-admin/print-agents");
  }

  listAllPrintAgentKeysAdmin() {
    return this.request<PrintAgentAdminKeyDto[]>("/super-admin/print-agents/keys");
  }

  adminRevokePrintAgent(id: string) {
    return this.request<{ success: boolean }>(`/super-admin/print-agents/${id}`, { method: "DELETE" });
  }

  adminRevokePrintAgentKey(id: string) {
    return this.request<{ success: boolean }>(`/super-admin/print-agents/keys/${id}`, { method: "DELETE" });
  }

  listBusinessLocationOptions() {
    return this.request<BusinessLocationOptionDto[]>("/company/business-locations");
  }

  updateBusinessLocationAutoPrint(
    id: string,
    input: { enabled: boolean; printerRole: "thermal" | "a4"; copies: number; thermalWidth?: "80mm" | "58mm" },
  ) {
    return this.request<{
      id: string;
      autoPrintEnabled: boolean;
      autoPrintPrinterRole: string;
      autoPrintCopies: number;
      autoPrintThermalWidth: string;
    }>(`/company/business-locations/${id}/auto-print`, { method: "PATCH", body: JSON.stringify(input) });
  }

  listCompanyBankAccounts() {
    return this.request<CompanyBankAccountDto[]>("/company/bank-accounts");
  }

  createCompanyBankAccount(payload: {
    accountNumber: string;
    iban?: string | null;
    bankName?: string | null;
    currency?: string;
  }) {
    return this.request<CompanyBankAccountDto>("/company/bank-accounts", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  setDefaultCompanyBankAccount(id: string) {
    return this.request<CompanyBankAccountDto[]>(`/company/bank-accounts/${id}/set-default`, {
      method: "POST",
    });
  }

  deleteCompanyBankAccount(id: string) {
    return this.request<CompanyBankAccountDto[]>(`/company/bank-accounts/${id}`, {
      method: "DELETE",
    });
  }

  getReportSummary(from: string, to: string) {
    return this.request<ReportSummaryDto>(
      `/reports/summary?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
    );
  }

  getBillingUsageReport(from: string, to: string) {
    return this.request<BillingUsageReportDto>(
      `/reports/billing-usage?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
    );
  }

  // --- Magacinsko poslovanje: kalkulacija nabavne cene, nalog magacinu -------
  getPurchaseCalculationByReceipt(goodsReceiptId: string) {
    return this.request<PurchaseCalculationDto | null>(
      `/purchase-calculations/by-receipt/${goodsReceiptId}`,
    );
  }

  createPurchaseCalculation(goodsReceiptId: string) {
    return this.request<PurchaseCalculationDto>(
      `/purchase-calculations/by-receipt/${goodsReceiptId}`,
      { method: "POST" },
    );
  }

  addPurchaseCalculationCost(calcId: string, payload: { name: string; amount: string }) {
    return this.request<PurchaseCalculationDto>(`/purchase-calculations/${calcId}/costs`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  removePurchaseCalculationCost(calcId: string, costId: string) {
    return this.request<PurchaseCalculationDto>(`/purchase-calculations/${calcId}/costs/${costId}`, {
      method: "DELETE",
    });
  }

  setPurchaseCalculationAllocationMethod(calcId: string, method: CostAllocationMethod) {
    return this.request<PurchaseCalculationDto>(`/purchase-calculations/${calcId}/allocation-method`, {
      method: "POST",
      body: JSON.stringify({ method }),
    });
  }

  calculatePurchaseCalculation(calcId: string) {
    return this.request<PurchaseCalculationDto>(`/purchase-calculations/${calcId}/calculate`, {
      method: "POST",
    });
  }

  updatePurchaseCalculationItemPricing(
    calcId: string,
    itemId: string,
    payload: { marginPercent?: string; sellingPriceGross?: string },
  ) {
    return this.request<PurchaseCalculationDto>(
      `/purchase-calculations/${calcId}/items/${itemId}/pricing`,
      { method: "POST", body: JSON.stringify(payload) },
    );
  }

  confirmPurchaseCalculation(calcId: string) {
    return this.request<PurchaseCalculationDto>(`/purchase-calculations/${calcId}/confirm`, {
      method: "POST",
    });
  }

  applyPurchaseCalculationToPriceList(calcId: string) {
    return this.request<{ appliedCount: number }>(
      `/purchase-calculations/${calcId}/apply-to-price-list`,
      { method: "POST" },
    );
  }

  listWarehouseIssueOrders() {
    return this.request<WarehouseIssueOrderDto[]>("/warehouse-issue-orders");
  }

  createWarehouseIssueOrder(salesDocumentId: string) {
    return this.request<WarehouseIssueOrderDto>(
      `/warehouse-issue-orders/for-document/${salesDocumentId}`,
      { method: "POST" },
    );
  }

  getWarehouseIssueOrder(id: string) {
    return this.request<WarehouseIssueOrderDto>(`/warehouse-issue-orders/${id}`);
  }

  issueWarehouseOrderItems(
    id: string,
    items: { itemId: string; issuedQuantity: string; issuedSerialNumbers?: string }[],
  ) {
    return this.request<WarehouseIssueOrderDto>(`/warehouse-issue-orders/${id}/issue`, {
      method: "POST",
      body: JSON.stringify({ items }),
    });
  }

  // --- Shopify integracija (vidi docs/shopify-integracija.md) -----------------
  getShopifyInstallUrl(shop: string) {
    return this.request<{ url: string; shop: string }>(
      `/integrations/shopify/install?shop=${encodeURIComponent(shop)}`,
    );
  }

  listShopifyStores() {
    return this.request<ShopifyStoreDto[]>("/integrations/shopify/stores");
  }

  getShopifySettings(storeId: string) {
    return this.request<ShopifySettingsResponseDto>(`/integrations/shopify/stores/${storeId}/settings`);
  }

  updateShopifySettings(storeId: string, payload: ShopifySettingsUpdatePayload) {
    return this.request<ShopifySettingsResponseDto>(`/integrations/shopify/stores/${storeId}/settings`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  }

  listShopifyOrders(storeId: string, params?: { status?: string; limit?: number; offset?: number }) {
    const qs = new URLSearchParams();
    if (params?.status) qs.set("status", params.status);
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.offset) qs.set("offset", String(params.offset));
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<ShopifyOrdersResponseDto>(`/integrations/shopify/stores/${storeId}/orders${suffix}`);
  }

  retryShopifyOrder(storeId: string, syncId: string) {
    return this.request<ShopifyOrderSyncDto>(`/integrations/shopify/stores/${storeId}/orders/${syncId}/retry`, {
      method: "POST",
    });
  }

  retryShopifyRefund(storeId: string, refundSyncId: string) {
    return this.request<ShopifyRefundSyncDto>(
      `/integrations/shopify/stores/${storeId}/refunds/${refundSyncId}/retry`,
      { method: "POST" },
    );
  }

  registerShopifyWebhooks(storeId: string) {
    return this.request<{ registered: string[]; errors: string[] }>(
      `/integrations/shopify/stores/${storeId}/webhooks/register`,
      { method: "POST" },
    );
  }

  disconnectShopifyStore(storeId: string) {
    return this.request<{ disconnected: boolean; note: string }>(`/integrations/shopify/stores/${storeId}`, {
      method: "DELETE",
    });
  }

  // --- MerchantPro integracija (vidi docs/timovi/integracije-merchantpro-povezivanje.md) ---
  listMerchantProStores() {
    return this.request<MerchantProStoreDto[]>("/integrations/merchantpro/stores");
  }

  createMerchantProStore(payload: CreateMerchantProStorePayload) {
    return this.request<MerchantProStoreDto>("/integrations/merchantpro/stores", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateMerchantProStore(storeId: string, payload: UpdateMerchantProStorePayload) {
    return this.request<MerchantProStoreDto>(`/integrations/merchantpro/stores/${storeId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  testMerchantProConnection(storeId: string) {
    return this.request<{ ok: boolean; error: string | null }>(
      `/integrations/merchantpro/stores/${storeId}/test-connection`,
      { method: "POST" },
    );
  }

  enableMerchantProStore(storeId: string) {
    return this.request<MerchantProStoreDto>(`/integrations/merchantpro/stores/${storeId}/enable`, {
      method: "POST",
    });
  }

  disableMerchantProStore(storeId: string) {
    return this.request<MerchantProStoreDto>(`/integrations/merchantpro/stores/${storeId}/disable`, {
      method: "POST",
    });
  }

  syncMerchantProStoreNow(storeId: string) {
    return this.request<unknown>(`/integrations/merchantpro/stores/${storeId}/sync-now`, {
      method: "POST",
    });
  }

  disconnectMerchantProStore(storeId: string) {
    return this.request<{ disconnected: boolean }>(`/integrations/merchantpro/stores/${storeId}`, {
      method: "DELETE",
    });
  }

  listMerchantProOrders(storeId: string, params?: { status?: string; limit?: number; offset?: number }) {
    const qs = new URLSearchParams();
    if (params?.status) qs.set("status", params.status);
    if (params?.limit) qs.set("limit", String(params.limit));
    if (params?.offset) qs.set("offset", String(params.offset));
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<MerchantProOrdersResponseDto>(`/integrations/merchantpro/stores/${storeId}/orders${suffix}`);
  }

  retryMerchantProOrder(storeId: string, syncId: string) {
    return this.request<MerchantProOrderSyncDto>(
      `/integrations/merchantpro/stores/${storeId}/orders/${syncId}/retry`,
      { method: "POST" },
    );
  }

  updateMerchantProOrderSerial(storeId: string, syncId: string, equipmentSerialNumber: string | null) {
    return this.request<{ id: string; equipmentSerialNumber: string | null }>(
      `/integrations/merchantpro/stores/${storeId}/orders/${syncId}/serial`,
      { method: "PATCH", body: JSON.stringify({ equipmentSerialNumber }) },
    );
  }

  generateMerchantProWebhookToken(storeId: string) {
    return this.request<MerchantProWebhookInfoDto>(`/integrations/merchantpro/stores/${storeId}/webhook-token`, {
      method: "POST",
    });
  }

  getMerchantProWebhookInfo(storeId: string) {
    return this.request<MerchantProWebhookInfoDto>(`/integrations/merchantpro/stores/${storeId}/webhook-info`);
  }

  importMerchantProProducts(storeId: string) {
    return this.request<MerchantProImportProductsResultDto>(`/integrations/merchantpro/stores/${storeId}/products/import`, {
      method: "POST",
    });
  }

  listMerchantProProducts(storeId: string) {
    return this.request<MerchantProProductMappingDto[]>(`/integrations/merchantpro/stores/${storeId}/products`);
  }

  updateMerchantProProductMapping(mappingId: string, payload: UpdateMerchantProProductMappingPayload) {
    return this.request<{ ok: true }>(`/integrations/merchantpro/products/${mappingId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getCloudApiActivityLog() {
    return this.request<CloudApiActivityLogEntryDto[]>("/cloud-api/integrations/activity-log");
  }

  listCloudApiWebhooks() {
    return this.request<CloudApiWebhookDto[]>("/cloud-api/webhooks");
  }

  createCloudApiWebhook(payload: CreateCloudApiWebhookPayload) {
    return this.request<CloudApiWebhookDto & { secret: string }>("/cloud-api/webhooks", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  disableCloudApiWebhook(id: string) {
    return this.request<void>(`/cloud-api/webhooks/${id}/disable`, { method: "POST" });
  }

  listCloudApiNetworkDevices() {
    return this.request<CloudApiNetworkDeviceDto[]>("/cloud-api/network-devices");
  }

  // --- Otpremnica ---------------------------------------------------------
  getDeliveryNoteForDocument(salesDocumentId: string) {
    return this.request<DeliveryNoteDto | null>(`/delivery-notes/for-document/${salesDocumentId}`);
  }

  createDeliveryNote(salesDocumentId: string) {
    return this.request<DeliveryNoteDto>(`/delivery-notes/for-document/${salesDocumentId}`, {
      method: "POST",
    });
  }

  sendDeliveryNoteEmail(id: string) {
    return this.request<{ success: boolean }>(`/delivery-notes/${id}/send-email`, { method: "POST" });
  }

  listDeliveryNotes() {
    return this.request<DeliveryNoteDto[]>("/delivery-notes");
  }

  getPublicDeliveryNote(token: string) {
    return this.request<PublicDeliveryNoteDto>(`/public/delivery-notes/${token}`);
  }

  confirmPublicDeliveryNote(token: string, payload: ConfirmDeliveryNotePayload) {
    return this.request<PublicDeliveryNoteDto>(`/public/delivery-notes/${token}/confirm`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  // --- Sales documents (Ponude/Fakture - Faza 2) --------------------------
  listSalesDocuments(params?: {
    type?: SalesDocumentType;
    status?: SalesDocumentStatus;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  }) {
    const qs = new URLSearchParams();
    if (params?.type) qs.set("type", params.type);
    if (params?.status) qs.set("status", params.status);
    if (params?.search) qs.set("search", params.search);
    if (params?.dateFrom) qs.set("dateFrom", params.dateFrom);
    if (params?.dateTo) qs.set("dateTo", params.dateTo);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<SalesDocumentDto[]>(`/sales-documents${suffix}`);
  }

  createSalesDocument(payload: CreateSalesDocumentPayload) {
    return this.request<SalesDocumentDto>("/sales-documents", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  getSalesDocument(id: string) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}`);
  }

  updateSalesDocument(
    id: string,
    payload: {
      customerId?: string | null;
      issueDate?: string;
      validUntilOrDueDate?: string | null;
      paymentTerms?: string | null;
      deliveryTerms?: string | null;
      customerNote?: string | null;
      internalNote?: string | null;
      discountAmount?: string;
      shippingAmount?: string;
    },
  ) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  addSalesDocumentItem(id: string, payload: AddSalesDocumentItemPayload) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/items`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateSalesDocumentItem(id: string, itemId: string, payload: UpdateSalesDocumentItemPayload) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/items/${itemId}`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  removeSalesDocumentItem(id: string, itemId: string) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/items/${itemId}`, {
      method: "DELETE",
    });
  }

  sendSalesDocument(id: string) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/send`, { method: "POST" });
  }

  approveSalesDocument(id: string) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/approve`, { method: "POST" });
  }

  acceptSalesDocument(id: string) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/accept`, { method: "POST" });
  }

  rejectSalesDocument(id: string) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/reject`, { method: "POST" });
  }

  cancelSalesDocument(id: string) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/cancel`, { method: "POST" });
  }

  deleteSalesDocument(id: string) {
    return this.request<{ success: boolean }>(`/sales-documents/${id}`, { method: "DELETE" });
  }

  convertQuoteToInvoice(id: string, payload: ConvertQuoteToInvoicePayload) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/convert-to-invoice`, {
      method: "POST",
      body: JSON.stringify(payload),
      idempotencyKey: payload.idempotencyKey,
    });
  }

  registerSalesDocumentPayment(id: string, payload: RegisterSalesDocumentPaymentPayload) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/payment`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  /** "Transaction log" IPS QR pokušaja za fakturu (uspešnih i neuspešnih) - vidi razgovor "transaction logs". */
  getIpsTransactions(id: string) {
    return this.request<IpsPgwTransactionDto[]>(`/sales-documents/${id}/ips-transactions`);
  }

  /** Isto kao getIpsTransactions, ali za pokušaje plaćanja karticom (OTP Banka). */
  getOtpCardTransactions(id: string) {
    return this.request<OtpCardTransactionDto[]>(`/sales-documents/${id}/otp-card-transactions`);
  }

  /** Isto kao getOtpCardTransactions, ali za pokušaje plaćanja preko Banca Intesa (NestPay). */
  getIntesaCardTransactions(id: string) {
    return this.request<IntesaCardTransactionDto[]>(`/sales-documents/${id}/intesa-card-transactions`);
  }

  /** Isto kao getOtpCardTransactions, ali za pokušaje plaćanja preko Raiffeisen banke (UPC). */
  getRaiffeisenCardTransactions(id: string) {
    return this.request<RaiffeisenCardTransactionDto[]>(`/sales-documents/${id}/raiffeisen-card-transactions`);
  }

  sendSalesDocumentEmail(id: string, payload: { to?: string; message?: string }) {
    return this.request<SalesDocumentDto>(`/sales-documents/${id}/send-email`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  // --- Admin ponude (08.10.2026) ---------------------------------------------
  listAdminOffers() {
    return this.request<AdminOfferDto[]>("/super-admin/offers");
  }

  searchOfferProducts(q: string) {
    return this.request<OfferProductDto[]>(`/super-admin/offers/product-search?q=${encodeURIComponent(q)}`);
  }

  importOfferProductFromWoo(code: string) {
    return this.request<OfferProductDto>("/super-admin/offers/import-woo", { method: "POST", body: JSON.stringify({ code }) });
  }

  createAdminOffer(payload: AdminOfferInput) {
    return this.request<AdminOfferDto>("/super-admin/offers", { method: "POST", body: JSON.stringify(payload) });
  }

  updateAdminOffer(id: string, payload: AdminOfferInput) {
    return this.request<AdminOfferDto>(`/super-admin/offers/${id}`, { method: "PATCH", body: JSON.stringify(payload) });
  }

  sendAdminOffer(id: string) {
    return this.request<AdminOfferDto>(`/super-admin/offers/${id}/send`, { method: "POST" });
  }

  deleteAdminOffer(id: string) {
    return this.request<{ success: boolean }>(`/super-admin/offers/${id}`, { method: "DELETE" });
  }

  getPublicOffer(token: string) {
    return this.request<PublicOfferDto>(`/public/offers/${token}`);
  }

  acceptPublicOffer(token: string) {
    return this.request<PublicOfferDto>(`/public/offers/${token}/accept`, { method: "POST" });
  }

  declinePublicOffer(token: string) {
    return this.request<PublicOfferDto>(`/public/offers/${token}/decline`, { method: "POST" });
  }

  // --- Javni pregled ponude (bez naloga) -------------------------------------
  getPublicQuote(token: string) {
    return this.request<SalesDocumentDto>(`/public/quotes/${token}`);
  }

  acceptPublicQuote(token: string) {
    return this.request<SalesDocumentDto>(`/public/quotes/${token}/accept`, { method: "POST" });
  }

  rejectPublicQuote(token: string) {
    return this.request<SalesDocumentDto>(`/public/quotes/${token}/reject`, { method: "POST" });
  }

  // --- Javni pregled i plaćanje fakture (bez naloga) -------------------------
  getPublicInvoice(token: string) {
    return this.request<SalesDocumentDto>(`/public/invoices/${token}`);
  }

  createPublicInvoiceIpsPayment(token: string) {
    return this.request<{ qrCodeURL: string; transactionId: string }>(
      `/public/invoices/${token}/ips-payment`,
      { method: "POST" },
    );
  }

  /** Pollovano dok je IPS QR modal otvoren - vidi razgovor "u realnom vremenu". */
  getPublicIpsPaymentStatus(token: string, transactionId: string) {
    return this.request<{ status: "PENDING" | "SUCCESS" | "FAILED"; responseCode: string | null; paymentReference: string | null }>(
      `/public/invoices/${token}/ips-payment/${transactionId}/status`,
    );
  }

  /**
   * Priprema plaćanje karticom (OTP Banka VPOS) - vraća polja za skrivenu
   * POST formu koju frontend mora da submituje ka `gatewayUrl` (kupac
   * napušta Finora i ide na stranicu banke - nema modala/iframe-a kao kod
   * IPS QR, zbog 3D Secure unosa podataka kartice).
   */
  createPublicInvoiceOtpCardPayment(token: string) {
    return this.request<{ gatewayUrl: string; fields: Record<string, string>; transactionId: string }>(
      `/public/invoices/${token}/otp-card-payment`,
      { method: "POST" },
    );
  }

  getPublicOtpCardPaymentStatus(token: string, transactionId: string) {
    return this.request<{ status: "PENDING" | "SUCCESS" | "FAILED"; resultCode: string | null }>(
      `/public/invoices/${token}/otp-card-payment/${transactionId}/status`,
    );
  }

  /** Isto kao createPublicInvoiceOtpCardPayment, ali za Banca Intesa (NestPay). */
  createPublicInvoiceIntesaCardPayment(token: string) {
    return this.request<{ gatewayUrl: string; fields: Record<string, string>; transactionId: string }>(
      `/public/invoices/${token}/intesa-card-payment`,
      { method: "POST" },
    );
  }

  getPublicIntesaCardPaymentStatus(token: string, transactionId: string) {
    return this.request<{ status: "PENDING" | "SUCCESS" | "FAILED"; response: string | null }>(
      `/public/invoices/${token}/intesa-card-payment/${transactionId}/status`,
    );
  }

  /** Isto kao createPublicInvoiceOtpCardPayment, ali za Raiffeisen banku (UPC). */
  createPublicInvoiceRaiffeisenCardPayment(token: string) {
    return this.request<{ gatewayUrl: string; fields: Record<string, string>; transactionId: string }>(
      `/public/invoices/${token}/raiffeisen-card-payment`,
      { method: "POST" },
    );
  }

  getPublicRaiffeisenCardPaymentStatus(token: string, transactionId: string) {
    return this.request<{ status: "PENDING" | "SUCCESS" | "FAILED"; tranCode: string | null }>(
      `/public/invoices/${token}/raiffeisen-card-payment/${transactionId}/status`,
    );
  }

  // --- Ponavljajuće fakture ---------------------------------------------------
  listRecurringInvoiceTemplates() {
    return this.request<RecurringInvoiceTemplateDto[]>("/recurring-invoices");
  }

  getRecurringInvoiceTemplate(id: string) {
    return this.request<RecurringInvoiceTemplateDto>(`/recurring-invoices/${id}`);
  }

  createRecurringInvoiceTemplate(payload: CreateRecurringInvoiceTemplatePayload) {
    return this.request<RecurringInvoiceTemplateDto>("/recurring-invoices", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateRecurringInvoiceTemplate(
    id: string,
    payload: { active?: boolean; autoSend?: boolean; endDate?: string | null },
  ) {
    return this.request<RecurringInvoiceTemplateDto>(`/recurring-invoices/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  // --- Bankovni izvodi ---------------------------------------------------------
  listBankStatements() {
    return this.request<BankStatementDto[]>("/bank-statements");
  }

  getBankStatement(id: string) {
    return this.request<BankStatementDto>(`/bank-statements/${id}`);
  }

  approveBankStatement(id: string) {
    return this.request<BankStatementDto>(`/bank-statements/${id}/approve`, { method: "POST" });
  }

  deleteBankStatement(id: string) {
    return this.request<{ success: boolean }>(`/bank-statements/${id}`, { method: "DELETE" });
  }

  getBankStatementLineCandidates(lineId: string) {
    return this.request<BankStatementCandidateDto[]>(`/bank-statements/lines/${lineId}/candidates`);
  }

  searchBankStatementLines(query: string) {
    return this.request<
      Array<{
        id: string;
        statementId: string;
        statementNumber: string | null;
        statementDate: string;
        payerName: string | null;
        description: string | null;
        amount: string;
        direction: string;
        status: string;
        valueDate: string;
      }>
    >(`/bank-statements/lines/search?q=${encodeURIComponent(query)}`);
  }

  bookBankStatementLine(lineId: string, documentId: string) {
    return this.request<BankStatementLineDto>(`/bank-statements/lines/${lineId}/book`, {
      method: "POST",
      body: JSON.stringify({ documentId }),
    });
  }

  ignoreBankStatementLine(lineId: string) {
    return this.request<BankStatementLineDto>(`/bank-statements/lines/${lineId}/ignore`, {
      method: "POST",
    });
  }

  getReconciliationMode() {
    return this.request<{ reconciliationMode: ReconciliationMode }>(
      "/bank-statements/reconciliation-mode",
    );
  }

  setReconciliationMode(mode: ReconciliationMode) {
    return this.request<{ reconciliationMode: ReconciliationMode }>(
      "/bank-statements/reconciliation-mode",
      { method: "PATCH", body: JSON.stringify({ reconciliationMode: mode }) },
    );
  }

  /**
   * Upload fajla ide MIMO generičkog `request()` helper-a - ne sme se
   * postaviti "Content-Type: application/json" (browser sam postavlja
   * ispravan multipart boundary), i telo je FormData, ne JSON string.
   */
  async importBankStatement(file: File): Promise<BankStatementDto> {
    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(`${this.options.baseUrl}/bank-statements/import-file`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });

    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Uvoz izvoda nije uspeo. Pokušajte ponovo.",
          path: "/bank-statements/import-file",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as BankStatementDto;
  }

  // --- Modul "Ugovor" (vidi ugovor-modul-todo.md) --------------------------

  listContractTemplates() {
    return this.request<ContractTemplateDto[]>("/super-admin/contracts/templates");
  }

  createContractTemplate(payload: { name: string; bodyText: string; placeholders: ContractPlaceholderDefDto[] }) {
    return this.request<ContractTemplateDto>("/super-admin/contracts/templates", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateContractTemplate(id: string, payload: Partial<ContractTemplateDto>) {
    return this.request<ContractTemplateDto>(`/super-admin/contracts/templates/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  getCompanyContractSettings(companyId: string) {
    return this.request<ContractSettingsDto | null>(`/super-admin/contracts/companies/${companyId}/settings`);
  }

  getContractProviderSettings() {
    return this.request<ContractProviderSettingsDto>("/super-admin/contracts/provider-settings");
  }

  upsertContractProviderSettings(
    payload: {
      representativeName?: string | null;
      esirApprovalNumber?: string | null;
      esirApprovalDate?: string | null;
      paymentDueDays?: number;
      suspensionDays?: number;
      courtCity?: string;
      slaPremiumPrice?: number;
      contractDiscount12Percent?: number;
      contractDiscount24Percent?: number;
    },
  ) {
    return this.request<ContractProviderSettingsDto>("/super-admin/contracts/provider-settings", {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  /**
   * Admin "Generiši ugovor" dugme, PRVI klik (01.10.2026) - kreira stvaran
   * Contract red (idempotentno, vidi backend ContractsAdminService.generateContract)
   * tako da ugovor postane vidljiv i na profilu firme i klijentu na "Moj
   * ugovor". Pozvati PRE fetchContractPreviewPdfBlobUrl da pregled odmah
   * odražava njegovo (podrazumevano) trajanje/SLA.
   */
  generateContract(companyId: string, payload?: { slaPremiumPriceOverride?: number | null; discountPercentOverride?: number | null; durationOption?: "UNDEFINED" | "MONTHS_12" | "MONTHS_24" }) {
    return this.request<ContractDto>(`/super-admin/contracts/companies/${companyId}/generate`, {
      method: "POST",
      body: JSON.stringify(payload ?? {}),
    });
  }

  /**
   * Admin "Generiši ugovor" PDF pregled (uvek dostupno, čak i bez prihvaćenog
   * ugovora firme). Ruta je iza SuperAdminGuard (Bearer token), pa se - za
   * razliku od getContractPdfUrl (tenant ruta, bez guard-a) - NE može
   * otvoriti kao običan <a href> (preglednik ne šalje Authorization header
   * na navigaciju) - vraća Blob URL koji se otvara sa window.open().
   */
  async fetchContractPreviewPdfBlobUrl(companyId: string): Promise<string> {
    const res = await fetch(`${this.options.baseUrl}/super-admin/contracts/companies/${companyId}/preview-pdf`, {
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Generisanje PDF pregleda ugovora nije uspelo.",
          path: `/super-admin/contracts/companies/${companyId}/preview-pdf`,
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  }

  upsertCompanyContractSettings(
    companyId: string,
    payload: {
      representativeName?: string | null;
      esirApprovalDate?: string | null;
      signingPlace?: string | null;
      customFields?: Record<string, string> | null;
    },
  ) {
    return this.request<ContractSettingsDto>(`/super-admin/contracts/companies/${companyId}/settings`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  listAdminContracts(companyId?: string) {
    const query = companyId ? `?companyId=${encodeURIComponent(companyId)}` : "";
    return this.request<ContractDto[]>(`/super-admin/contracts${query}`);
  }

  getAdminContract(id: string) {
    return this.request<ContractDto>(`/super-admin/contracts/${id}`);
  }

  reviewContract(id: string, payload: { decision: "APPROVED" | "REJECTED"; rejectionReason?: string }) {
    return this.request<ContractDto>(`/super-admin/contracts/${id}/review`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  getMyContracts() {
    return this.request<ContractDto[]>("/company/contracts");
  }

  getContractDiscountedPrice(packageId: string, durationOption: ContractDurationOption) {
    return this.request<ContractDiscountedPriceDto>(
      `/company/contracts/discounted-price?packageId=${encodeURIComponent(packageId)}&durationOption=${durationOption}`,
    );
  }

  acceptContract(payload: AcceptContractPayload) {
    return this.request<ContractDto>("/company/contracts/accept", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  /** Vraća direktan URL za download (koristi se u <a href>/window.open, ne fetch - PDF se šalje kao binarni stream). */
  getContractPdfUrl(contractId: string) {
    return `${this.options.baseUrl}/company/contracts/${contractId}/pdf`;
  }

  /** Upload je MIMO generičkog `request()` helper-a - isti razlog kao importBankStatement iznad. */
  async uploadContractDocuments(contractId: string, files: File[]): Promise<ContractDto> {
    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }

    const res = await fetch(`${this.options.baseUrl}/company/contracts/${contractId}/documents`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });

    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Upload potpisanog ugovora nije uspeo. Pokušajte ponovo.",
          path: `/company/contracts/${contractId}/documents`,
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as ContractDto;
  }

  // --- "Finora Admin -> Bekap baze" (26.09.2026, modul prepisan sa svih 11
  // sigurnosnih ispravki - vidi claude/bekap-baze-modul.md; originalni,
  // nikad deploy-ovan dizajn od 23.09.2026 je zamenjen) --------------------

  restartApiService() {
    return this.request<{ restarting: boolean }>("/super-admin/system/restart", { method: "POST" });
  }

  // E-arhiv ---------------------------------------------------------------
  // --- WISP ------------------------------------------------------------------
  getWispOverview() {
    return this.request<WispOverviewDto>("/wisp/overview");
  }
  listWispPlans() {
    return this.request<WispPlanDto[]>("/wisp/plans");
  }
  createWispPlan(payload: WispPlanPayload) {
    return this.request<WispPlanDto[]>("/wisp/plans", { method: "POST", body: JSON.stringify(payload) });
  }
  updateWispPlan(id: string, payload: WispPlanPayload) {
    return this.request<WispPlanDto[]>(`/wisp/plans/${id}`, { method: "PATCH", body: JSON.stringify(payload) });
  }
  deleteWispPlan(id: string) {
    return this.request<WispPlanDto[]>(`/wisp/plans/${id}`, { method: "DELETE" });
  }
  listWispNas() {
    return this.request<WispNasDto[]>("/wisp/nas");
  }
  createWispNas(name: string, radiusServerId: string) {
    return this.request<WispNasDto[]>("/wisp/nas", { method: "POST", body: JSON.stringify({ name, radiusServerId }) });
  }
  renameWispNas(id: string, name: string) {
    return this.request<WispNasDto[]>(`/wisp/nas/${id}`, { method: "PATCH", body: JSON.stringify({ name }) });
  }
  deleteWispNas(id: string) {
    return this.request<WispNasDto[]>(`/wisp/nas/${id}`, { method: "DELETE" });
  }
  getWispNasScript(id: string) {
    return this.request<{ name: string; script: string }>(`/wisp/nas/${id}/script`);
  }
  listWispSubscribers(params?: { search?: string; status?: string }) {
    const qs = new URLSearchParams();
    if (params?.search) qs.set("search", params.search);
    if (params?.status) qs.set("status", params.status);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<WispSubscriberRowDto[]>(`/wisp/subscribers${suffix}`);
  }
  getWispSubscriber(id: string) {
    return this.request<WispSubscriberDetailDto>(`/wisp/subscribers/${id}`);
  }
  createWispSubscriber(payload: WispSubscriberPayload) {
    return this.request<{ id: string; username: string; password: string }>("/wisp/subscribers", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
  updateWispSubscriber(id: string, payload: WispSubscriberPayload) {
    return this.request<WispSubscriberDetailDto>(`/wisp/subscribers/${id}`, { method: "PATCH", body: JSON.stringify(payload) });
  }
  revealWispPassword(id: string) {
    return this.request<{ username: string; password: string }>(`/wisp/subscribers/${id}/password`, { method: "POST" });
  }
  setWispSubscriberStatus(id: string, status: WispStatus, reason?: string) {
    return this.request<WispSubscriberDetailDto>(`/wisp/subscribers/${id}/status`, {
      method: "POST",
      body: JSON.stringify({ status, reason }),
    });
  }
  deleteWispSubscriber(id: string) {
    return this.request<{ ok: boolean }>(`/wisp/subscribers/${id}`, { method: "DELETE" });
  }
  listWispServers() {
    return this.request<WispRadiusServerDto[]>("/wisp/servers");
  }
  createWispServer(payload: WispRadiusServerPayload) {
    return this.request<WispRadiusServerDto[]>("/wisp/servers", { method: "POST", body: JSON.stringify(payload) });
  }
  updateWispServer(id: string, payload: WispRadiusServerPayload) {
    return this.request<WispRadiusServerDto[]>(`/wisp/servers/${id}`, { method: "PATCH", body: JSON.stringify(payload) });
  }
  deleteWispServer(id: string) {
    return this.request<WispRadiusServerDto[]>(`/wisp/servers/${id}`, { method: "DELETE" });
  }
  rotateWispServerToken(id: string) {
    return this.request<{ token: string; installCommand: string }>(`/wisp/servers/${id}/token`, { method: "POST" });
  }
  getSmsSettings() {
    return this.request<SmsSettingsDto>("/wisp/sms/settings");
  }
  saveSmsSettings(payload: SmsSettingsPayload) {
    return this.request<SmsSettingsDto>("/wisp/sms/settings", { method: "PUT", body: JSON.stringify(payload) });
  }
  private async wispImport<T>(path: string, file: File, format: WispImportFormat, opts: WispImportOptions): Promise<T> {
    const formData = new FormData();
    formData.append("format", format);
    if (opts.defaultPlanId) formData.append("defaultPlanId", opts.defaultPlanId);
    formData.append("missingPassword", opts.missingPassword ?? "GENERATE");
    formData.append("file", file);
    const res = await fetch(`${this.options.baseUrl}${path}`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Uvoz nije uspeo.",
          path,
          timestamp: new Date().toISOString(),
        };
      }
      if (res.status === 401) this.options.onUnauthorized?.();
      throw new ApiError(body);
    }
    return (await res.json()) as T;
  }
  previewWispImport(file: File, format: WispImportFormat, opts: WispImportOptions) {
    return this.wispImport<WispImportPreviewDto>("/wisp/import/preview", file, format, opts);
  }
  commitWispImport(file: File, format: WispImportFormat, opts: WispImportOptions) {
    return this.wispImport<WispImportResultDto>("/wisp/import/commit", file, format, opts);
  }
  async downloadWispImportTemplate(): Promise<Blob> {
    const res = await fetch(`${this.options.baseUrl}/wisp/import/template`, { headers: { ...(this.options.getAuthHeaders?.() ?? {}) } });
    if (!res.ok) throw new Error("Preuzimanje tabele nije uspelo.");
    return res.blob();
  }
  getWispAdminOverview() {
    return this.request<WispAdminOverviewDto>("/super-admin/wisp/overview");
  }
  sendTestSms(payload: { provider?: "KANNEL" | "YEASTAR"; to: string; text?: string }) {
    return this.request<SmsTestResultDto>("/wisp/sms/test", { method: "POST", body: JSON.stringify(payload) });
  }

  getEarhivSettings() {
    return this.request<EarhivSettingsDto>("/earhiv/settings");
  }
  saveEarhivSettings(payload: EarhivSettingsDto) {
    return this.request<EarhivSettingsDto>("/earhiv/settings", { method: "PUT", body: JSON.stringify(payload) });
  }
  listEarhivCategories() {
    return this.request<EarhivCategoryDto[]>("/earhiv/categories");
  }
  loadEarhivTemplate() {
    return this.request<{ added: number; total: number; templateVersion: string }>("/earhiv/categories/template", {
      method: "POST",
    });
  }
  createEarhivCategory(payload: EarhivCategoryPayload) {
    return this.request<EarhivCategoryDto>("/earhiv/categories", { method: "POST", body: JSON.stringify(payload) });
  }
  updateEarhivCategory(id: string, payload: EarhivCategoryPayload) {
    return this.request<EarhivCategoryDto>(`/earhiv/categories/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }
  deleteEarhivCategory(id: string) {
    return this.request<{ ok: boolean }>(`/earhiv/categories/${id}`, { method: "DELETE" });
  }
  listEarhivYears() {
    return this.request<Array<{ year: number; entries: number }>>("/earhiv/book/years");
  }
  listEarhivEntries(year?: number) {
    return this.request<EarhivEntryDto[]>(`/earhiv/book${year ? `?year=${year}` : ""}`);
  }
  generateEarhivYear(year: number) {
    return this.request<{ year: number; created: number; updated: number; skippedLocked: number; skippedEmpty: number }>(
      "/earhiv/book/generate",
      { method: "POST", body: JSON.stringify({ year }) },
    );
  }
  createEarhivEntry(payload: EarhivEntryPayload) {
    return this.request<EarhivEntryDto>("/earhiv/book", { method: "POST", body: JSON.stringify(payload) });
  }
  updateEarhivEntry(id: string, payload: EarhivEntryPayload) {
    return this.request<EarhivEntryDto>(`/earhiv/book/${id}`, { method: "PATCH", body: JSON.stringify(payload) });
  }
  /** PDF/Excel prepis knjige: ruta traži login, pa se preuzima fetch-om i vraća kao Blob URL. */
  async fetchEarhivExportBlobUrl(kind: "pdf" | "xlsx", year?: number): Promise<string> {
    const res = await fetch(`${this.options.baseUrl}/earhiv/export/${kind}${year ? `?year=${year}` : ""}`, {
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      if (res.status === 401) this.options.onUnauthorized?.();
      let message = `Izvoz nije uspeo (HTTP ${res.status}).`;
      try {
        const body = (await res.json()) as { message?: string | string[] };
        if (body.message) message = Array.isArray(body.message) ? body.message.join(" ") : body.message;
      } catch {
        /* telo nije JSON */
      }
      throw new Error(message);
    }
    return URL.createObjectURL(await res.blob());
  }
  lockEarhivYear(year: number) {
    return this.request<{ year: number; locked: number }>("/earhiv/book/lock", {
      method: "POST",
      body: JSON.stringify({ year }),
    });
  }
  getEarhivStorage() {
    return this.request<EarhivStorageDto>("/earhiv/storage");
  }
  adminLpfrDevices() {
    return this.request<LpfrDevicesDto>("/super-admin/lpfr/devices");
  }
  adminLpfrDeviceHistory(id: string) {
    return this.request<{ at: string; ip: string | null; outcome: string; jid: string | null; version: string | null }[]>(`/super-admin/lpfr/devices/${id}/history`);
  }
  adminLpfrBlock(type: string, value: string, reason?: string) {
    return this.request<{ success: boolean }>("/super-admin/lpfr/blocks", { method: "POST", body: JSON.stringify({ type, value, reason }) });
  }
  adminLpfrUnblock(type: string, value: string) {
    return this.request<{ success: boolean }>("/super-admin/lpfr/unblock", { method: "POST", body: JSON.stringify({ type, value }) });
  }
  adminListHub() {
    return this.request<HubDeviceDto[]>("/super-admin/hub");
  }
  adminSetHubDisabled(id: string, disabled: boolean) {
    return this.request<{ success: boolean }>(`/super-admin/hub/${id}`, { method: "PATCH", body: JSON.stringify({ disabled }) });
  }
  adminDeleteHub(id: string) {
    return this.request<{ success: boolean }>(`/super-admin/hub/${id}`, { method: "DELETE" });
  }
  getLpfrAdminOverview() {
    return this.request<LpfrAdminOverviewDto>("/super-admin/lpfr/overview");
  }
  previewCompanyAprSync(companyId: string) {
    return this.request<CompanyAprSyncPreviewDto>(`/super-admin/companies/${companyId}/apr-sync`);
  }
  applyCompanyAprSync(companyId: string, payload: { fields: string[]; accounts: string[] }) {
    return this.request<{ updatedFields: number; addedAccounts: number }>(`/super-admin/companies/${companyId}/apr-sync`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
  listNormativIngredients() {
    return this.request<NormativIngredientDto[]>("/normativ/ingredients");
  }
  createNormativIngredient(payload: { name: string; unit?: string; sku?: string }) {
    return this.request<NormativIngredientDto>("/normativ/ingredients", { method: "POST", body: JSON.stringify(payload) });
  }
  setNormativIngredientFlag(productId: string, isIngredient: boolean) {
    return this.request<{ id: string; isIngredient: boolean }>(`/normativ/ingredients/${productId}`, {
      method: "PATCH",
      body: JSON.stringify({ isIngredient }),
    });
  }
  listNormativRecipes() {
    return this.request<Array<{ productId: string; name: string; ingredients: number }>>("/normativ/recipes");
  }
  getNormativRecipe(productId: string) {
    return this.request<NormativRecipeLineDto[]>(`/normativ/products/${productId}/recipe`);
  }
  setNormativRecipe(productId: string, lines: NormativRecipeLinePayload[]) {
    return this.request<NormativRecipeLineDto[]>(`/normativ/products/${productId}/recipe`, {
      method: "PUT",
      body: JSON.stringify({ lines }),
    });
  }
  setNormativOption(optionId: string, payload: { ingredientProductId: string | null; ingredientQuantity?: string | number | null }) {
    return this.request<unknown>(`/normativ/options/${optionId}`, { method: "PUT", body: JSON.stringify(payload) });
  }
  getNormativConsumption(params: { from?: string; to?: string }) {
    const qs = new URLSearchParams();
    if (params.from) qs.set("from", params.from);
    if (params.to) qs.set("to", params.to);
    return this.request<NormativConsumptionRowDto[]>(`/normativ/reports/consumption?${qs.toString()}`);
  }
  getNormativAddonSales(params: { from?: string; to?: string }) {
    const qs = new URLSearchParams();
    if (params.from) qs.set("from", params.from);
    if (params.to) qs.set("to", params.to);
    return this.request<NormativAddonSaleRowDto[]>(`/normativ/reports/addons?${qs.toString()}`);
  }
  getNormativMovements(params: { from?: string; to?: string; negativeOnly?: boolean }) {
    const qs = new URLSearchParams();
    if (params.from) qs.set("from", params.from);
    if (params.to) qs.set("to", params.to);
    if (params.negativeOnly) qs.set("negativeOnly", "true");
    return this.request<NormativMovementDto[]>(`/normativ/movements?${qs.toString()}`);
  }
  getEarhivAdminStorage() {
    return this.request<EarhivAdminStorageDto>("/super-admin/earhiv/storage");
  }
  setEarhivAdminQuota(companyId: string, quotaGb: number) {
    return this.request<{ ok: boolean; quotaGb: number }>(`/super-admin/earhiv/storage/${companyId}/quota`, {
      method: "POST",
      body: JSON.stringify({ quotaGb }),
    });
  }
  revealEarhivAdminSecret(companyId: string) {
    return this.request<EarhivAdminSecretDto>(`/super-admin/earhiv/storage/${companyId}/secret`, { method: "POST" });
  }
  listEarhivFiles(params?: { categoryId?: string; year?: number }) {
    const qs = new URLSearchParams();
    if (params?.categoryId) qs.set("categoryId", params.categoryId);
    if (params?.year) qs.set("year", String(params.year));
    return this.request<EarhivFileDto[]>(`/earhiv/files${qs.toString() ? `?${qs.toString()}` : ""}`);
  }
  async uploadEarhivFile(file: File, categoryId: string, year: number, description?: string) {
    const formData = new FormData();
    formData.append("categoryId", categoryId);
    formData.append("year", String(year));
    if (description) formData.append("description", description);
    formData.append("file", file);
    const res = await fetch(`${this.options.baseUrl}/earhiv/files`, {
      method: "POST",
      body: formData,
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      if (res.status === 401) this.options.onUnauthorized?.();
      let body: ApiErrorResponse;
      try {
        body = (await res.json()) as ApiErrorResponse;
      } catch {
        body = {
          statusCode: res.status,
          errorCode: "UNKNOWN_ERROR",
          message: "Slanje fajla nije uspelo. Pokušajte ponovo.",
          path: "/earhiv/files",
          timestamp: new Date().toISOString(),
        };
      }
      throw new ApiError(body);
    }
    return (await res.json()) as { id: string; fileName: string; sha256: string; sizeBytes: number };
  }
  async downloadEarhivFile(id: string, fileName: string): Promise<void> {
    const res = await fetch(`${this.options.baseUrl}/earhiv/files/${id}/download`, {
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      if (res.status === 401) this.options.onUnauthorized?.();
      let message = `Preuzimanje nije uspelo (HTTP ${res.status}).`;
      try {
        const b = (await res.json()) as { message?: string | string[] };
        if (b.message) message = Array.isArray(b.message) ? b.message.join(" ") : b.message;
      } catch {
        /* nije JSON */
      }
      throw new Error(message);
    }
    const url = URL.createObjectURL(await res.blob());
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }
  /** Za pregled u novom prozoru: vraća blob adresu fajla sa zadatim (bezbednim) tipom. */
  async fetchEarhivFileBlobUrl(id: string, mimeType: string): Promise<string> {
    const res = await fetch(`${this.options.baseUrl}/earhiv/files/${id}/download`, {
      headers: { ...(this.options.getAuthHeaders?.() ?? {}) },
    });
    if (!res.ok) {
      if (res.status === 401) this.options.onUnauthorized?.();
      throw new Error(`Pregled nije uspeo (HTTP ${res.status}).`);
    }
    return URL.createObjectURL(new Blob([await res.blob()], { type: mimeType }));
  }
  deleteEarhivFile(id: string) {
    return this.request<{ ok: boolean }>(`/earhiv/files/${id}`, { method: "DELETE" });
  }
  deleteEarhivEntry(id: string) {
    return this.request<{ ok: boolean }>(`/earhiv/book/${id}`, { method: "DELETE" });
  }

  listBackupDestinations() {
    return this.request<BackupDestinationsListDto>("/super-admin/backup/destinations");
  }

  createBackupDestination(payload: BackupDestinationPayload) {
    return this.request<BackupDestinationDto>("/super-admin/backup/destinations", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateBackupDestination(id: string, payload: Partial<BackupDestinationPayload>) {
    return this.request<BackupDestinationDto>(`/super-admin/backup/destinations/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  deleteBackupDestination(id: string) {
    return this.request<{ deleted: boolean }>(`/super-admin/backup/destinations/${id}`, { method: "DELETE" });
  }

  testBackupDestination(id: string) {
    return this.request<{ ok: boolean }>(`/super-admin/backup/destinations/${id}/test`, { method: "POST" });
  }

  runBackupNow(id: string) {
    return this.request<BackupRunDto>(`/super-admin/backup/destinations/${id}/run`, { method: "POST" });
  }

  listBackupRuns(id: string) {
    return this.request<BackupRunDto[]>(`/super-admin/backup/destinations/${id}/runs`);
  }

  listBackupRestores() {
    return this.request<BackupRestoreRequestDto[]>("/super-admin/backup/restores");
  }

  createBackupRestore(body: { companyId: string; targetTime: string; mode: "PREVIEW" | "APPLY" }) {
    return this.request<BackupRestoreRequestDto>("/super-admin/backup/restores", {
      method: "POST",
      body: JSON.stringify(body),
    });
  }

  /**
   * Jedino mesto koje briše bekap sa udaljenog odredišta - uvek pojedinačno,
   * uvek eksplicitna admin akcija. Server odbija (409) ako je ovo poslednji
   * validan bekap tog odredišta (tačka 2 checklist-a).
   */
  deleteBackupRun(runId: string) {
    return this.request<{ deleted: boolean }>(`/super-admin/backup/runs/${runId}`, { method: "DELETE" });
  }

  // --- "Troškovi" (Web UI, 30.09.2026 - vidi claude/troskovi-modul-todo.md;
  // backend/ExpensesModule je mergovan ranije preko PR #13) -----------------

  listExpenses(params?: { from?: string; to?: string }) {
    const qs = new URLSearchParams();
    if (params?.from) qs.set("from", params.from);
    if (params?.to) qs.set("to", params.to);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.request<ExpenseDto[]>(`/expenses${suffix}`);
  }

  createExpense(payload: CreateExpensePayload) {
    return this.request<ExpenseDto>("/expenses", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  updateExpense(id: string, payload: UpdateExpensePayload) {
    return this.request<ExpenseDto>(`/expenses/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }

  deleteExpense(id: string) {
    return this.request<void>(`/expenses/${id}`, { method: "DELETE" });
  }

  getExpenseSettings() {
    return this.request<ExpenseSettingsDto>("/expenses/settings");
  }

  updateExpenseSettings(payload: UpdateExpenseSettingsPayload) {
    return this.request<ExpenseSettingsDto>("/expenses/settings", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
}

export interface GmailImportDto {
  id: string;
  gmailAddress: string;
  provider: "GMAIL" | "IMAP";
  imapHost: string | null;
  imapPort: number | null;
  imapSecure: boolean;
  imapUser: string | null;
  subjectFilters: string[];
  sinceDate: string;
  isActive: boolean;
  lastRunAt: string | null;
  lastStatus: string | null;
  lastError: string | null;
  lastImportedCount: number;
  totalImportedCount: number;
  running: boolean;
}

export interface WooConnectorDto {
  siteUrl: string;
  mode: "PLUGIN" | "WC_KEYS";
  isActive: boolean;
  pricesNet: boolean;
  lastCheckAt: string | null;
  lastStatus: string | null;
  lastError: string | null;
}


export interface AdminOfferItem {
  moduleId?: string | null;
  name: string;
  price: string;
  kind?: "OTHER" | null;
  sku?: string | null;
  qty?: number | null;
  unit?: string | null;
  discount?: number | null;
}

export interface OfferProductDto {
  id: string;
  name: string;
  sku: string;
  net: number;
}

export interface AdminOfferCustomerExtra {
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;
  phone?: string;
  bankAccounts?: { accountNumber: string; bankName?: string | null }[];
}

export interface AdminOfferInput {
  customerExtra?: AdminOfferCustomerExtra | null;
  companyId?: string | null;
  customerName?: string;
  customerTaxId?: string;
  customerRegNumber?: string;
  customerAddress?: string;
  customerEmail?: string;
  customerContactName?: string;
  packageId?: string | null;
  items: AdminOfferItem[];
  billingPeriod: "MONTHLY" | "YEARLY";
  durationOption: "NONE" | "UNDEFINED" | "MONTHS_12" | "MONTHS_24";
  validUntil?: string | null;
  note?: string | null;
}

export interface AdminOfferDto {
  customerExtra?: AdminOfferCustomerExtra | null;
  id: string;
  number: string;
  token: string;
  status: "DRAFT" | "SENT" | "ACCEPTED" | "DECLINED";
  companyId: string | null;
  companyName: string | null;
  customerName: string;
  customerTaxId: string | null;
  customerRegNumber: string | null;
  customerAddress: string | null;
  customerEmail: string;
  customerContactName: string | null;
  packageId: string | null;
  items: AdminOfferItem[];
  total: string;
  vatPercent: number;
  vatAmount: string;
  totalWithVat: string;
  billingPeriod: "MONTHLY" | "YEARLY";
  durationOption: "NONE" | "UNDEFINED" | "MONTHS_12" | "MONTHS_24";
  validUntil: string | null;
  note: string | null;
  sentAt: string | null;
  acceptedAt: string | null;
  declinedAt: string | null;
  contractId: string | null;
  recurringTemplateId: string | null;
  acceptError: string | null;
  createdAt: string;
  publicUrl: string;
}

export interface PublicOfferDto {
  number: string;
  status: "SENT" | "ACCEPTED" | "DECLINED" | "EXPIRED";
  customerName: string;
  items: AdminOfferItem[];
  total: string;
  vatPercent: number;
  vatAmount: string;
  totalWithVat: string;
  billingPeriod: "MONTHLY" | "YEARLY";
  durationOption: "NONE" | "UNDEFINED" | "MONTHS_12" | "MONTHS_24";
  validUntil: string | null;
  note: string | null;
}

export interface BackupRestoreRequestDto {
  id: string;
  companyId: string;
  companyName: string;
  targetTime: string;
  mode: "PREVIEW" | "APPLY";
  status: "QUEUED" | "RUNNING" | "DONE" | "FAILED";
  output: string | null;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
}

export interface HubStatusDto {
  cpuTempC: number | null; load1: number | null; ramFreeMb: number | null; ramTotalMb: number | null;
  diskFreeMb: number | null; diskTotalMb: number | null; uptimeSeconds: number | null; throttled: boolean | null;
  network: string | null; wifiSsid: string | null; signalDbm: number | null;
  cardReader: string | null; cardPresent: boolean | null;
  taxCoreLastContact: string | null; taxCoreLastError: string | null;
  pendingQueue: number | null; signedToday: number | null; signedTotal: number | null;
  lastInvoiceAt: string | null; lastError: string | null; localTime: string | null; tz: string | null;
}
export interface HubDeviceDto {
  id: string; companyId: string; companyName: string; taxId: string; serial: string; name: string | null;
  hwModel: string | null; osVersion: string | null; hubVersion: string | null; lpfrVersion: string | null;
  jid: string | null; ip: string | null; status: HubStatusDto | null;
  firstSeenAt: string; lastSeenAt: string; online: boolean; disabled: boolean;
  paket: { label: string | null; kind: string; activeUntil: string | null; location: string | null } | null;
}

export interface LpfrDeviceRowDto {
  id: string; machineId: string; serialNumber: string | null; platform: string | null; version: string | null;
  jid: string | null; tin: string | null; hostname: string | null; deviceModel: string | null; ip: string | null;
  companyId: string | null; companyName: string | null; companyTaxId: string | null;
  licenseKeyId: string | null; keyPrefix: string | null; noLicense: boolean;
  lastOutcome: string | null; calls: number; firstSeenAt: string; lastSeenAt: string;
  blocked: { device: boolean; jid: boolean; tin: boolean; license: boolean };
}
export interface LpfrDevicesDto {
  blocks: { type: string; value: string; reason: string | null; createdAt: string }[];
  devices: LpfrDeviceRowDto[];
}

// --- WISP (RADIUS za MikroTik PPPoE) i SMS - 27.10.2026 --------------------------
export type WispStatus = "ACTIVE" | "SUSPENDED" | "DISABLED";
export interface WispOverviewDto {
  active: number; suspended: number; disabled: number; online: number; nas: number; plans: number;
  servers: number; serversOnline: number; radiusReady: boolean;
}
export interface WispPlanDto {
  id: string; name: string; downloadMbps: number; uploadMbps: number;
  productId: string | null; productName: string | null; active: boolean; subscribers: number;
}
export interface WispPlanPayload {
  name?: string; downloadMbps?: number; uploadMbps?: number; productId?: string | null; active?: boolean;
}
export interface WispNasDto {
  id: string; name: string; tunnelIp: string; radiusServerId: string | null; radiusServerName: string | null; ready: boolean;
  lastRequestAt: string | null; online: number; createdAt: string;
}
export interface WispSubscriberRowDto {
  id: string; username: string; customerId: string; customerName: string; phone: string | null; address: string | null;
  planId: string; planName: string; staticIp: string | null; status: WispStatus; statusReason: string | null;
  statusChangedAt: string; online: boolean; framedIp: string | null; lastAuthAt: string | null; lastAuthResult: string | null;
  note: string | null;
}
export interface WispSubscriberDetailDto {
  id: string; username: string;
  customer: { id: string; name: string; phone: string | null; email: string | null; address: string | null; city: string | null } | null;
  planId: string; planName: string; staticIp: string | null; status: WispStatus; statusReason: string | null;
  statusChangedAt: string; note: string | null; lastAuthAt: string | null; lastAuthResult: string | null;
  logs: { id: string; fromStatus: string; toStatus: string; reason: string | null; source: string; userName: string | null; createdAt: string }[];
  sessions: {
    id: string; nasName: string; framedIp: string | null; callingStation: string | null; startedAt: string; updatedAt: string;
    stoppedAt: string | null; terminateCause: string | null; downloadBytes: number; uploadBytes: number;
  }[];
}
export interface WispSubscriberPayload {
  customerId?: string;
  newCustomer?: { name: string; phone?: string; email?: string; address?: string; city?: string };
  username?: string; password?: string; planId?: string; staticIp?: string | null; note?: string | null;
}
export interface WispRadiusServerDto {
  id: string; name: string; host: string | null; wgPort: number; tunnelNetwork: string; serverTunnelIp: string | null;
  authPort: number; acctPort: number; coaPort: number; nasCount: number; ready: boolean;
  agent: {
    tokenSet: boolean; tokenPrefix: string | null; online: boolean; lastSeenAt: string | null; version: string | null;
    hostname: string | null; radiusActive: boolean | null; lastError: string | null;
  };
  installCommandTemplate: string;
  createdAt: string;
}
export interface WispRadiusServerPayload {
  name?: string; host?: string | null; wgPort?: number; tunnelNetwork?: string; authPort?: number; acctPort?: number; coaPort?: number;
}
export interface SmsSettingsDto {
  kannel: { enabled: boolean; url: string | null; user: string | null; passwordSet: boolean; from: string | null; smsc: string | null };
  yeastar: { enabled: boolean; url: string | null; apiVersion: string; user: string | null; passwordSet: boolean; trunk: string | null };
  smsPrimary: "KANNEL" | "YEASTAR";
  thisMonth: { sent: number; failed: number };
  recent: { id: string; to: string; text: string; provider: string; status: string; error: string | null; createdAt: string }[];
}
export interface SmsSettingsPayload {
  kannelEnabled?: boolean; kannelUrl?: string | null; kannelUser?: string | null; kannelPassword?: string | null;
  kannelFrom?: string | null; kannelSmsc?: string | null;
  yeastarEnabled?: boolean; yeastarUrl?: string | null; yeastarApiVersion?: string; yeastarUser?: string | null;
  yeastarPassword?: string | null; yeastarTrunk?: string | null;
  smsPrimary?: "KANNEL" | "YEASTAR";
}
export interface WispAdminOverviewDto {
  servers: {
    id: string; companyName: string; taxId: string | null; name: string; host: string | null; online: boolean;
    radiusActive: boolean | null; lastSeenAt: string | null; version: string | null; lastError: string | null;
    nasCount: number; subscribers: number;
  }[];
  smsThisMonth: { companyName: string; sent: number; failed: number }[];
}
export interface SmsTestResultDto {
  ok: boolean; provider: "KANNEL" | "YEASTAR" | null; messageId: string | null; error: string | null;
  tried: { provider: "KANNEL" | "YEASTAR"; ok: boolean; error: string | null }[];
}

export type WispImportFormat = "FREERADIUS_SQL" | "USERMANAGER" | "PPP_SECRETS" | "TABLE";
export interface WispImportOptions {
  defaultPlanId?: string | null;
  missingPassword?: "GENERATE" | "SKIP";
}
export interface WispImportPreviewDto {
  format: WispImportFormat;
  total: number;
  toImport: number;
  skipped: number;
  newPasswords: number;
  disabled: number;
  suspended: number;
  newPlans: { name: string; downloadMbps: number; uploadMbps: number }[];
  rows: {
    source: string; username: string; name: string | null; phone: string | null; address: string | null; plan: string | null;
    staticIp: string | null; status: WispStatus; action: "NEW" | "SKIP"; reason: string | null; newPassword: boolean; warnings: string[];
  }[];
}
export interface WispImportResultDto {
  created: number;
  skipped: number;
  newPlans: string[];
  generatedPasswords: { username: string; password: string }[];
}
